package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Serbia Flag (20x15dp)
 *
 * - ISO Alpha-2: RS
 * - ISO Alpha-3: SRB
 * - ISO Numeric: 688
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.Serbia: ImageVector by lazy {
    ImageVector.Builder(
        name = "Serbia:RS:SRB:688:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF4857A1)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(5f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 10f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(10f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF6C540)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.16f, 2.377f)
                lineTo(7.089f, 2.094f)
                curveTo(7.149f, 2.112f, 7.215f, 2.131f, 7.284f, 2.151f)
                lineTo(7.283f, 2.147f)
                curveTo(8.108f, 2.222f, 9.384f, 2.649f, 9.621f, 3.103f)
                curveTo(9.713f, 3.278f, 9.622f, 3.427f, 9.502f, 3.623f)
                curveTo(9.484f, 3.652f, 9.466f, 3.683f, 9.447f, 3.714f)
                curveTo(9.387f, 3.816f, 9.332f, 3.914f, 9.281f, 4.006f)
                curveTo(9.096f, 4.337f, 8.951f, 4.596f, 8.731f, 4.728f)
                lineTo(8.736f, 5.479f)
                lineTo(5.051f, 5.447f)
                lineTo(5.046f, 4.689f)
                curveTo(4.858f, 4.548f, 4.723f, 4.307f, 4.555f, 4.006f)
                lineTo(4.555f, 4.006f)
                lineTo(4.555f, 4.006f)
                lineTo(4.555f, 4.006f)
                lineTo(4.555f, 4.006f)
                curveTo(4.503f, 3.914f, 4.449f, 3.816f, 4.389f, 3.714f)
                curveTo(4.37f, 3.683f, 4.352f, 3.652f, 4.334f, 3.623f)
                lineTo(4.334f, 3.623f)
                curveTo(4.214f, 3.427f, 4.123f, 3.278f, 4.215f, 3.103f)
                curveTo(4.393f, 2.761f, 5.202f, 2.43f, 5.943f, 2.254f)
                curveTo(6.089f, 2.203f, 6.241f, 2.154f, 6.392f, 2.108f)
                lineTo(6.459f, 2.157f)
                curveTo(6.518f, 2.149f, 6.575f, 2.142f, 6.629f, 2.137f)
                lineTo(6.714f, 2.326f)
                horizontalLineTo(7.014f)
                curveTo(7.014f, 2.326f, 7.195f, 2.864f, 7.195f, 3.163f)
                curveTo(7.195f, 3.462f, 7.014f, 3.709f, 7.014f, 3.709f)
                verticalLineTo(3.915f)
                curveTo(7.046f, 3.917f, 7.079f, 3.921f, 7.113f, 3.924f)
                curveTo(7.113f, 3.906f, 7.115f, 3.888f, 7.118f, 3.868f)
                curveTo(7.136f, 3.77f, 7.19f, 3.697f, 7.239f, 3.706f)
                curveTo(7.288f, 3.714f, 7.314f, 3.801f, 7.297f, 3.9f)
                curveTo(7.294f, 3.916f, 7.29f, 3.931f, 7.285f, 3.946f)
                curveTo(7.48f, 3.972f, 7.698f, 4.009f, 7.904f, 4.047f)
                curveTo(7.983f, 3.895f, 8.078f, 3.744f, 8.17f, 3.6f)
                lineTo(8.17f, 3.6f)
                curveTo(8.406f, 3.229f, 8.614f, 2.903f, 8.42f, 2.709f)
                curveTo(8.383f, 2.672f, 8.317f, 2.637f, 8.231f, 2.605f)
                curveTo(7.948f, 2.535f, 7.639f, 2.481f, 7.34f, 2.453f)
                lineTo(7.331f, 2.404f)
                curveTo(7.271f, 2.394f, 7.213f, 2.385f, 7.16f, 2.377f)
                close()
                moveTo(8.56f, 4.177f)
                curveTo(8.665f, 4.199f, 8.728f, 4.213f, 8.728f, 4.213f)
                lineTo(8.729f, 4.32f)
                curveTo(9.094f, 4.039f, 9.352f, 3.415f, 9.376f, 3.211f)
                curveTo(9.39f, 3.088f, 9.194f, 2.946f, 8.888f, 2.817f)
                curveTo(9.033f, 3.092f, 8.839f, 3.365f, 8.596f, 3.707f)
                curveTo(8.504f, 3.836f, 8.406f, 3.974f, 8.315f, 4.126f)
                lineTo(8.405f, 4.144f)
                curveTo(8.404f, 4.116f, 8.408f, 4.084f, 8.416f, 4.052f)
                curveTo(8.442f, 3.955f, 8.503f, 3.887f, 8.551f, 3.9f)
                curveTo(8.599f, 3.913f, 8.617f, 4.002f, 8.591f, 4.099f)
                curveTo(8.584f, 4.128f, 8.573f, 4.154f, 8.56f, 4.177f)
                close()
                moveTo(6.677f, 3.916f)
                verticalLineTo(3.687f)
                curveTo(6.677f, 3.687f, 6.52f, 3.511f, 6.496f, 3.146f)
                curveTo(6.479f, 2.885f, 6.533f, 2.578f, 6.565f, 2.424f)
                curveTo(6.331f, 2.454f, 6.084f, 2.5f, 5.845f, 2.557f)
                curveTo(5.686f, 2.601f, 5.56f, 2.652f, 5.504f, 2.709f)
                curveTo(5.31f, 2.903f, 5.518f, 3.229f, 5.754f, 3.6f)
                lineTo(5.754f, 3.6f)
                lineTo(5.754f, 3.6f)
                curveTo(5.842f, 3.739f, 5.935f, 3.884f, 6.012f, 4.031f)
                curveTo(6.145f, 4.002f, 6.279f, 3.976f, 6.404f, 3.955f)
                curveTo(6.398f, 3.935f, 6.395f, 3.914f, 6.393f, 3.892f)
                curveTo(6.384f, 3.792f, 6.417f, 3.708f, 6.467f, 3.704f)
                curveTo(6.517f, 3.699f, 6.564f, 3.776f, 6.573f, 3.876f)
                curveTo(6.575f, 3.894f, 6.575f, 3.912f, 6.574f, 3.928f)
                curveTo(6.61f, 3.924f, 6.644f, 3.92f, 6.677f, 3.916f)
                close()
                moveTo(5.608f, 4.125f)
                curveTo(5.518f, 3.973f, 5.42f, 3.835f, 5.328f, 3.707f)
                lineTo(5.328f, 3.707f)
                lineTo(5.328f, 3.707f)
                curveTo(5.079f, 3.357f, 4.882f, 3.08f, 5.046f, 2.799f)
                curveTo(4.688f, 2.938f, 4.446f, 3.088f, 4.46f, 3.211f)
                curveTo(4.482f, 3.404f, 4.714f, 3.971f, 5.047f, 4.271f)
                curveTo(5.071f, 4.264f, 5.2f, 4.228f, 5.381f, 4.182f)
                curveTo(5.368f, 4.16f, 5.355f, 4.134f, 5.346f, 4.105f)
                curveTo(5.315f, 4.01f, 5.328f, 3.92f, 5.376f, 3.905f)
                curveTo(5.424f, 3.889f, 5.487f, 3.954f, 5.518f, 4.049f)
                curveTo(5.529f, 4.082f, 5.534f, 4.114f, 5.535f, 4.143f)
                lineTo(5.608f, 4.125f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.283f, 2.191f)
                curveTo(7.283f, 2.411f, 7.1f, 2.589f, 6.875f, 2.589f)
                curveTo(6.65f, 2.589f, 6.467f, 2.411f, 6.467f, 2.191f)
                curveTo(6.467f, 1.972f, 6.65f, 1.793f, 6.875f, 1.793f)
                curveTo(7.1f, 1.793f, 7.283f, 1.972f, 7.283f, 2.191f)
                close()
                moveTo(6.875f, 5.145f)
                curveTo(7.05f, 5.145f, 7.192f, 5.064f, 7.192f, 4.964f)
                curveTo(7.192f, 4.864f, 7.05f, 4.783f, 6.875f, 4.783f)
                curveTo(6.7f, 4.783f, 6.558f, 4.864f, 6.558f, 4.964f)
                curveTo(6.558f, 5.064f, 6.7f, 5.145f, 6.875f, 5.145f)
                close()
                moveTo(5.29f, 5.1f)
                curveTo(5.29f, 5.175f, 5.229f, 5.236f, 5.154f, 5.236f)
                curveTo(5.079f, 5.236f, 5.018f, 5.175f, 5.018f, 5.1f)
                curveTo(5.018f, 5.025f, 5.079f, 4.964f, 5.154f, 4.964f)
                curveTo(5.229f, 4.964f, 5.29f, 5.025f, 5.29f, 5.1f)
                close()
                moveTo(8.913f, 5.1f)
                curveTo(8.913f, 5.175f, 8.852f, 5.236f, 8.777f, 5.236f)
                curveTo(8.702f, 5.236f, 8.641f, 5.175f, 8.641f, 5.1f)
                curveTo(8.641f, 5.025f, 8.702f, 4.964f, 8.777f, 4.964f)
                curveTo(8.852f, 4.964f, 8.913f, 5.025f, 8.913f, 5.1f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC5363C)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.196f, 5.009f)
                curveTo(6.196f, 5.084f, 6.094f, 5.145f, 5.969f, 5.145f)
                curveTo(5.844f, 5.145f, 5.743f, 5.084f, 5.743f, 5.009f)
                curveTo(5.743f, 4.934f, 5.844f, 4.873f, 5.969f, 4.873f)
                curveTo(6.094f, 4.873f, 6.196f, 4.934f, 6.196f, 5.009f)
                close()
                moveTo(8.098f, 5.009f)
                curveTo(8.098f, 5.084f, 7.996f, 5.145f, 7.871f, 5.145f)
                curveTo(7.746f, 5.145f, 7.645f, 5.084f, 7.645f, 5.009f)
                curveTo(7.645f, 4.934f, 7.746f, 4.873f, 7.871f, 4.873f)
                curveTo(7.996f, 4.873f, 8.098f, 4.934f, 8.098f, 5.009f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.645f, 3.877f)
                curveTo(7.645f, 3.977f, 7.604f, 4.058f, 7.554f, 4.058f)
                curveTo(7.504f, 4.058f, 7.464f, 3.977f, 7.464f, 3.877f)
                curveTo(7.464f, 3.777f, 7.504f, 3.696f, 7.554f, 3.696f)
                curveTo(7.604f, 3.696f, 7.645f, 3.777f, 7.645f, 3.877f)
                close()
                moveTo(6.282f, 3.849f)
                curveTo(6.313f, 3.944f, 6.299f, 4.034f, 6.252f, 4.049f)
                curveTo(6.204f, 4.065f, 6.14f, 4f, 6.11f, 3.905f)
                curveTo(6.079f, 3.81f, 6.092f, 3.72f, 6.14f, 3.705f)
                curveTo(6.187f, 3.689f, 6.251f, 3.754f, 6.282f, 3.849f)
                close()
                moveTo(5.216f, 4.34f)
                curveTo(5.264f, 4.325f, 5.277f, 4.235f, 5.246f, 4.14f)
                curveTo(5.215f, 4.045f, 5.152f, 3.98f, 5.104f, 3.995f)
                curveTo(5.057f, 4.011f, 5.043f, 4.101f, 5.074f, 4.196f)
                curveTo(5.105f, 4.291f, 5.169f, 4.355f, 5.216f, 4.34f)
                close()
                moveTo(8.8f, 4.217f)
                curveTo(8.747f, 4.302f, 8.67f, 4.349f, 8.628f, 4.323f)
                curveTo(8.585f, 4.296f, 8.594f, 4.206f, 8.647f, 4.121f)
                curveTo(8.7f, 4.036f, 8.777f, 3.989f, 8.82f, 4.015f)
                curveTo(8.862f, 4.042f, 8.853f, 4.132f, 8.8f, 4.217f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.106f, 2.37f)
                curveTo(6.131f, 2.389f, 6.162f, 2.399f, 6.196f, 2.399f)
                curveTo(6.28f, 2.399f, 6.349f, 2.331f, 6.349f, 2.246f)
                curveTo(6.349f, 2.162f, 6.28f, 2.093f, 6.196f, 2.093f)
                curveTo(6.136f, 2.093f, 6.084f, 2.128f, 6.059f, 2.178f)
                curveTo(6.033f, 2.16f, 6.002f, 2.149f, 5.969f, 2.149f)
                curveTo(5.915f, 2.149f, 5.867f, 2.177f, 5.84f, 2.219f)
                curveTo(5.814f, 2.197f, 5.78f, 2.184f, 5.743f, 2.184f)
                curveTo(5.658f, 2.184f, 5.59f, 2.252f, 5.59f, 2.337f)
                curveTo(5.59f, 2.342f, 5.59f, 2.346f, 5.59f, 2.351f)
                curveTo(5.562f, 2.316f, 5.519f, 2.294f, 5.471f, 2.294f)
                curveTo(5.394f, 2.294f, 5.331f, 2.35f, 5.32f, 2.424f)
                curveTo(5.292f, 2.388f, 5.248f, 2.365f, 5.199f, 2.365f)
                curveTo(5.126f, 2.365f, 5.064f, 2.417f, 5.05f, 2.486f)
                curveTo(5.024f, 2.468f, 4.994f, 2.457f, 4.96f, 2.457f)
                curveTo(4.892f, 2.457f, 4.835f, 2.501f, 4.815f, 2.562f)
                curveTo(4.794f, 2.552f, 4.771f, 2.546f, 4.746f, 2.546f)
                curveTo(4.671f, 2.546f, 4.608f, 2.601f, 4.596f, 2.673f)
                curveTo(4.586f, 2.671f, 4.576f, 2.67f, 4.565f, 2.67f)
                curveTo(4.482f, 2.67f, 4.413f, 2.737f, 4.412f, 2.82f)
                curveTo(4.403f, 2.819f, 4.394f, 2.818f, 4.384f, 2.818f)
                curveTo(4.3f, 2.818f, 4.231f, 2.886f, 4.231f, 2.971f)
                curveTo(4.231f, 2.982f, 4.232f, 2.992f, 4.234f, 3.002f)
                curveTo(4.224f, 3f, 4.214f, 2.999f, 4.203f, 2.999f)
                curveTo(4.118f, 2.999f, 4.05f, 3.068f, 4.05f, 3.152f)
                curveTo(4.05f, 3.216f, 4.089f, 3.271f, 4.145f, 3.294f)
                curveTo(4.142f, 3.307f, 4.14f, 3.32f, 4.14f, 3.333f)
                curveTo(4.14f, 3.398f, 4.18f, 3.453f, 4.236f, 3.475f)
                curveTo(4.233f, 3.488f, 4.231f, 3.501f, 4.231f, 3.514f)
                curveTo(4.231f, 3.597f, 4.296f, 3.664f, 4.378f, 3.667f)
                curveTo(4.344f, 3.696f, 4.322f, 3.738f, 4.322f, 3.786f)
                curveTo(4.322f, 3.871f, 4.39f, 3.939f, 4.475f, 3.939f)
                curveTo(4.559f, 3.939f, 4.628f, 3.871f, 4.628f, 3.786f)
                curveTo(4.628f, 3.704f, 4.562f, 3.636f, 4.481f, 3.633f)
                curveTo(4.515f, 3.605f, 4.537f, 3.562f, 4.537f, 3.514f)
                curveTo(4.537f, 3.45f, 4.498f, 3.395f, 4.442f, 3.373f)
                curveTo(4.445f, 3.36f, 4.447f, 3.347f, 4.447f, 3.333f)
                curveTo(4.447f, 3.269f, 4.407f, 3.214f, 4.351f, 3.191f)
                curveTo(4.354f, 3.179f, 4.356f, 3.166f, 4.356f, 3.152f)
                curveTo(4.356f, 3.141f, 4.355f, 3.131f, 4.353f, 3.121f)
                curveTo(4.363f, 3.123f, 4.373f, 3.124f, 4.384f, 3.124f)
                curveTo(4.468f, 3.124f, 4.536f, 3.057f, 4.537f, 2.973f)
                curveTo(4.546f, 2.975f, 4.556f, 2.976f, 4.565f, 2.976f)
                curveTo(4.641f, 2.976f, 4.704f, 2.921f, 4.716f, 2.849f)
                curveTo(4.726f, 2.851f, 4.736f, 2.852f, 4.746f, 2.852f)
                curveTo(4.814f, 2.852f, 4.872f, 2.808f, 4.892f, 2.747f)
                curveTo(4.912f, 2.757f, 4.936f, 2.763f, 4.96f, 2.763f)
                curveTo(4.994f, 2.763f, 5.025f, 2.752f, 5.05f, 2.734f)
                curveTo(5.055f, 2.755f, 5.064f, 2.773f, 5.076f, 2.79f)
                curveTo(5.057f, 2.815f, 5.046f, 2.847f, 5.046f, 2.88f)
                curveTo(5.046f, 2.963f, 5.112f, 3.03f, 5.193f, 3.033f)
                curveTo(5.159f, 3.061f, 5.137f, 3.104f, 5.137f, 3.152f)
                curveTo(5.137f, 3.216f, 5.176f, 3.271f, 5.232f, 3.294f)
                curveTo(5.229f, 3.307f, 5.227f, 3.32f, 5.227f, 3.333f)
                curveTo(5.227f, 3.398f, 5.267f, 3.453f, 5.323f, 3.475f)
                curveTo(5.32f, 3.488f, 5.318f, 3.501f, 5.318f, 3.514f)
                curveTo(5.318f, 3.599f, 5.386f, 3.668f, 5.471f, 3.668f)
                curveTo(5.556f, 3.668f, 5.624f, 3.599f, 5.624f, 3.514f)
                curveTo(5.624f, 3.45f, 5.585f, 3.395f, 5.528f, 3.373f)
                curveTo(5.532f, 3.36f, 5.534f, 3.347f, 5.534f, 3.333f)
                curveTo(5.534f, 3.269f, 5.494f, 3.214f, 5.438f, 3.191f)
                curveTo(5.441f, 3.179f, 5.443f, 3.166f, 5.443f, 3.152f)
                curveTo(5.443f, 3.07f, 5.378f, 3.002f, 5.296f, 2.999f)
                curveTo(5.33f, 2.971f, 5.352f, 2.928f, 5.352f, 2.88f)
                curveTo(5.352f, 2.847f, 5.341f, 2.815f, 5.323f, 2.79f)
                curveTo(5.341f, 2.764f, 5.352f, 2.733f, 5.352f, 2.699f)
                curveTo(5.352f, 2.665f, 5.341f, 2.634f, 5.323f, 2.609f)
                curveTo(5.337f, 2.589f, 5.347f, 2.566f, 5.351f, 2.541f)
                curveTo(5.379f, 2.577f, 5.422f, 2.6f, 5.471f, 2.6f)
                curveTo(5.556f, 2.6f, 5.624f, 2.531f, 5.624f, 2.447f)
                curveTo(5.624f, 2.442f, 5.624f, 2.438f, 5.623f, 2.433f)
                curveTo(5.652f, 2.468f, 5.695f, 2.49f, 5.743f, 2.49f)
                curveTo(5.797f, 2.49f, 5.844f, 2.462f, 5.871f, 2.42f)
                curveTo(5.898f, 2.442f, 5.932f, 2.455f, 5.969f, 2.455f)
                curveTo(6.029f, 2.455f, 6.081f, 2.42f, 6.106f, 2.37f)
                close()
                moveTo(5.11f, 2.642f)
                curveTo(5.135f, 2.661f, 5.166f, 2.671f, 5.199f, 2.671f)
                curveTo(5.25f, 2.671f, 5.295f, 2.647f, 5.323f, 2.609f)
                curveTo(5.295f, 2.571f, 5.25f, 2.546f, 5.199f, 2.546f)
                curveTo(5.215f, 2.546f, 5.227f, 2.534f, 5.227f, 2.518f)
                curveTo(5.227f, 2.503f, 5.215f, 2.49f, 5.199f, 2.49f)
                curveTo(5.184f, 2.49f, 5.171f, 2.503f, 5.171f, 2.518f)
                curveTo(5.171f, 2.534f, 5.184f, 2.546f, 5.199f, 2.546f)
                curveTo(5.166f, 2.546f, 5.135f, 2.557f, 5.109f, 2.575f)
                curveTo(5.101f, 2.539f, 5.079f, 2.507f, 5.05f, 2.486f)
                curveTo(5.047f, 2.496f, 5.046f, 2.507f, 5.046f, 2.518f)
                curveTo(5.046f, 2.552f, 5.057f, 2.583f, 5.076f, 2.609f)
                curveTo(5.057f, 2.634f, 5.046f, 2.665f, 5.046f, 2.699f)
                curveTo(5.046f, 2.711f, 5.048f, 2.723f, 5.05f, 2.734f)
                curveTo(5.08f, 2.712f, 5.102f, 2.68f, 5.11f, 2.642f)
                close()
                moveTo(5.11f, 2.642f)
                curveTo(5.097f, 2.633f, 5.085f, 2.622f, 5.076f, 2.609f)
                curveTo(5.085f, 2.596f, 5.097f, 2.585f, 5.109f, 2.575f)
                curveTo(5.112f, 2.587f, 5.113f, 2.598f, 5.113f, 2.61f)
                curveTo(5.113f, 2.621f, 5.112f, 2.632f, 5.11f, 2.642f)
                close()
                moveTo(5.199f, 2.852f)
                curveTo(5.149f, 2.852f, 5.104f, 2.828f, 5.076f, 2.79f)
                curveTo(5.104f, 2.752f, 5.149f, 2.727f, 5.199f, 2.727f)
                curveTo(5.25f, 2.727f, 5.295f, 2.752f, 5.323f, 2.79f)
                curveTo(5.295f, 2.828f, 5.25f, 2.852f, 5.199f, 2.852f)
                close()
                moveTo(5.199f, 2.852f)
                curveTo(5.215f, 2.852f, 5.227f, 2.865f, 5.227f, 2.88f)
                curveTo(5.227f, 2.896f, 5.215f, 2.909f, 5.199f, 2.909f)
                curveTo(5.184f, 2.909f, 5.171f, 2.896f, 5.171f, 2.88f)
                curveTo(5.171f, 2.865f, 5.184f, 2.852f, 5.199f, 2.852f)
                close()
                moveTo(5.199f, 2.727f)
                curveTo(5.184f, 2.727f, 5.171f, 2.715f, 5.171f, 2.699f)
                curveTo(5.171f, 2.684f, 5.184f, 2.671f, 5.199f, 2.671f)
                curveTo(5.215f, 2.671f, 5.227f, 2.684f, 5.227f, 2.699f)
                curveTo(5.227f, 2.715f, 5.215f, 2.727f, 5.199f, 2.727f)
                close()
                moveTo(5.528f, 3.373f)
                curveTo(5.511f, 3.365f, 5.491f, 3.361f, 5.471f, 3.361f)
                curveTo(5.4f, 3.361f, 5.34f, 3.41f, 5.323f, 3.475f)
                curveTo(5.341f, 3.482f, 5.36f, 3.486f, 5.38f, 3.486f)
                curveTo(5.451f, 3.486f, 5.511f, 3.438f, 5.528f, 3.373f)
                close()
                moveTo(5.438f, 3.191f)
                curveTo(5.42f, 3.184f, 5.401f, 3.18f, 5.38f, 3.18f)
                curveTo(5.309f, 3.18f, 5.25f, 3.229f, 5.232f, 3.294f)
                curveTo(5.25f, 3.301f, 5.27f, 3.305f, 5.29f, 3.305f)
                curveTo(5.361f, 3.305f, 5.421f, 3.257f, 5.438f, 3.191f)
                close()
                moveTo(5.296f, 2.999f)
                lineTo(5.29f, 2.999f)
                curveTo(5.253f, 2.999f, 5.22f, 3.012f, 5.193f, 3.033f)
                lineTo(5.199f, 3.034f)
                curveTo(5.236f, 3.034f, 5.27f, 3.021f, 5.296f, 2.999f)
                close()
                moveTo(4.481f, 3.633f)
                lineTo(4.475f, 3.633f)
                curveTo(4.438f, 3.633f, 4.404f, 3.646f, 4.378f, 3.667f)
                lineTo(4.384f, 3.668f)
                curveTo(4.421f, 3.668f, 4.454f, 3.655f, 4.481f, 3.633f)
                close()
                moveTo(4.442f, 3.373f)
                curveTo(4.424f, 3.438f, 4.364f, 3.486f, 4.293f, 3.486f)
                curveTo(4.273f, 3.486f, 4.254f, 3.482f, 4.236f, 3.475f)
                curveTo(4.253f, 3.41f, 4.313f, 3.361f, 4.384f, 3.361f)
                curveTo(4.404f, 3.361f, 4.424f, 3.365f, 4.442f, 3.373f)
                close()
                moveTo(4.351f, 3.191f)
                curveTo(4.334f, 3.257f, 4.274f, 3.305f, 4.203f, 3.305f)
                curveTo(4.183f, 3.305f, 4.163f, 3.301f, 4.145f, 3.294f)
                curveTo(4.163f, 3.229f, 4.223f, 3.18f, 4.293f, 3.18f)
                curveTo(4.314f, 3.18f, 4.333f, 3.184f, 4.351f, 3.191f)
                close()
                moveTo(4.234f, 3.002f)
                curveTo(4.247f, 3.062f, 4.293f, 3.109f, 4.353f, 3.121f)
                curveTo(4.34f, 3.061f, 4.294f, 3.015f, 4.234f, 3.002f)
                close()
                moveTo(4.537f, 2.973f)
                curveTo(4.466f, 2.96f, 4.412f, 2.898f, 4.412f, 2.823f)
                lineTo(4.412f, 2.82f)
                curveTo(4.483f, 2.834f, 4.537f, 2.896f, 4.537f, 2.971f)
                lineTo(4.537f, 2.973f)
                close()
                moveTo(4.716f, 2.849f)
                curveTo(4.646f, 2.835f, 4.593f, 2.773f, 4.593f, 2.699f)
                curveTo(4.593f, 2.69f, 4.594f, 2.681f, 4.596f, 2.673f)
                curveTo(4.666f, 2.687f, 4.718f, 2.749f, 4.718f, 2.823f)
                curveTo(4.718f, 2.832f, 4.718f, 2.841f, 4.716f, 2.849f)
                close()
                moveTo(4.892f, 2.747f)
                curveTo(4.842f, 2.722f, 4.807f, 2.67f, 4.807f, 2.61f)
                curveTo(4.807f, 2.593f, 4.81f, 2.577f, 4.815f, 2.562f)
                curveTo(4.865f, 2.587f, 4.899f, 2.639f, 4.899f, 2.699f)
                curveTo(4.899f, 2.716f, 4.897f, 2.732f, 4.892f, 2.747f)
                close()
                moveTo(5.351f, 2.541f)
                curveTo(5.33f, 2.515f, 5.318f, 2.483f, 5.318f, 2.447f)
                curveTo(5.318f, 2.439f, 5.319f, 2.431f, 5.32f, 2.424f)
                curveTo(5.34f, 2.45f, 5.352f, 2.482f, 5.352f, 2.518f)
                curveTo(5.352f, 2.526f, 5.352f, 2.534f, 5.351f, 2.541f)
                close()
                moveTo(5.59f, 2.351f)
                curveTo(5.593f, 2.382f, 5.605f, 2.41f, 5.623f, 2.433f)
                curveTo(5.621f, 2.402f, 5.609f, 2.374f, 5.59f, 2.351f)
                close()
                moveTo(5.871f, 2.42f)
                curveTo(5.837f, 2.392f, 5.816f, 2.349f, 5.816f, 2.302f)
                curveTo(5.816f, 2.271f, 5.825f, 2.243f, 5.84f, 2.219f)
                curveTo(5.874f, 2.247f, 5.896f, 2.289f, 5.896f, 2.337f)
                curveTo(5.896f, 2.368f, 5.887f, 2.396f, 5.871f, 2.42f)
                close()
                moveTo(6.106f, 2.37f)
                curveTo(6.067f, 2.342f, 6.043f, 2.297f, 6.043f, 2.246f)
                curveTo(6.043f, 2.222f, 6.048f, 2.199f, 6.059f, 2.178f)
                curveTo(6.097f, 2.206f, 6.122f, 2.251f, 6.122f, 2.302f)
                curveTo(6.122f, 2.326f, 6.116f, 2.35f, 6.106f, 2.37f)
                close()
                moveTo(4.565f, 2.851f)
                curveTo(4.581f, 2.851f, 4.593f, 2.838f, 4.593f, 2.823f)
                curveTo(4.593f, 2.807f, 4.581f, 2.795f, 4.565f, 2.795f)
                curveTo(4.55f, 2.795f, 4.537f, 2.807f, 4.537f, 2.823f)
                curveTo(4.537f, 2.838f, 4.55f, 2.851f, 4.565f, 2.851f)
                close()
                moveTo(4.384f, 2.999f)
                curveTo(4.4f, 2.999f, 4.412f, 2.987f, 4.412f, 2.971f)
                curveTo(4.412f, 2.955f, 4.4f, 2.943f, 4.384f, 2.943f)
                curveTo(4.369f, 2.943f, 4.356f, 2.955f, 4.356f, 2.971f)
                curveTo(4.356f, 2.987f, 4.369f, 2.999f, 4.384f, 2.999f)
                close()
                moveTo(4.203f, 3.18f)
                curveTo(4.218f, 3.18f, 4.231f, 3.168f, 4.231f, 3.152f)
                curveTo(4.231f, 3.137f, 4.218f, 3.124f, 4.203f, 3.124f)
                curveTo(4.187f, 3.124f, 4.175f, 3.137f, 4.175f, 3.152f)
                curveTo(4.175f, 3.168f, 4.187f, 3.18f, 4.203f, 3.18f)
                close()
                moveTo(4.293f, 3.361f)
                curveTo(4.309f, 3.361f, 4.322f, 3.349f, 4.322f, 3.333f)
                curveTo(4.322f, 3.318f, 4.309f, 3.305f, 4.293f, 3.305f)
                curveTo(4.278f, 3.305f, 4.265f, 3.318f, 4.265f, 3.333f)
                curveTo(4.265f, 3.349f, 4.278f, 3.361f, 4.293f, 3.361f)
                close()
                moveTo(4.384f, 3.543f)
                curveTo(4.4f, 3.543f, 4.412f, 3.53f, 4.412f, 3.514f)
                curveTo(4.412f, 3.499f, 4.4f, 3.486f, 4.384f, 3.486f)
                curveTo(4.369f, 3.486f, 4.356f, 3.499f, 4.356f, 3.514f)
                curveTo(4.356f, 3.53f, 4.369f, 3.543f, 4.384f, 3.543f)
                close()
                moveTo(4.503f, 3.786f)
                curveTo(4.503f, 3.802f, 4.49f, 3.814f, 4.475f, 3.814f)
                curveTo(4.459f, 3.814f, 4.447f, 3.802f, 4.447f, 3.786f)
                curveTo(4.447f, 3.771f, 4.459f, 3.758f, 4.475f, 3.758f)
                curveTo(4.49f, 3.758f, 4.503f, 3.771f, 4.503f, 3.786f)
                close()
                moveTo(4.746f, 2.727f)
                curveTo(4.762f, 2.727f, 4.774f, 2.715f, 4.774f, 2.699f)
                curveTo(4.774f, 2.684f, 4.762f, 2.671f, 4.746f, 2.671f)
                curveTo(4.731f, 2.671f, 4.718f, 2.684f, 4.718f, 2.699f)
                curveTo(4.718f, 2.715f, 4.731f, 2.727f, 4.746f, 2.727f)
                close()
                moveTo(4.96f, 2.638f)
                curveTo(4.976f, 2.638f, 4.988f, 2.626f, 4.988f, 2.61f)
                curveTo(4.988f, 2.595f, 4.976f, 2.582f, 4.96f, 2.582f)
                curveTo(4.945f, 2.582f, 4.932f, 2.595f, 4.932f, 2.61f)
                curveTo(4.932f, 2.626f, 4.945f, 2.638f, 4.96f, 2.638f)
                close()
                moveTo(5.471f, 2.475f)
                curveTo(5.487f, 2.475f, 5.499f, 2.462f, 5.499f, 2.447f)
                curveTo(5.499f, 2.431f, 5.487f, 2.419f, 5.471f, 2.419f)
                curveTo(5.456f, 2.419f, 5.443f, 2.431f, 5.443f, 2.447f)
                curveTo(5.443f, 2.462f, 5.456f, 2.475f, 5.471f, 2.475f)
                close()
                moveTo(5.743f, 2.365f)
                curveTo(5.758f, 2.365f, 5.771f, 2.352f, 5.771f, 2.337f)
                curveTo(5.771f, 2.321f, 5.758f, 2.309f, 5.743f, 2.309f)
                curveTo(5.727f, 2.309f, 5.715f, 2.321f, 5.715f, 2.337f)
                curveTo(5.715f, 2.352f, 5.727f, 2.365f, 5.743f, 2.365f)
                close()
                moveTo(5.969f, 2.33f)
                curveTo(5.984f, 2.33f, 5.997f, 2.317f, 5.997f, 2.302f)
                curveTo(5.997f, 2.286f, 5.984f, 2.274f, 5.969f, 2.274f)
                curveTo(5.953f, 2.274f, 5.941f, 2.286f, 5.941f, 2.302f)
                curveTo(5.941f, 2.317f, 5.953f, 2.33f, 5.969f, 2.33f)
                close()
                moveTo(6.196f, 2.274f)
                curveTo(6.211f, 2.274f, 6.224f, 2.262f, 6.224f, 2.246f)
                curveTo(6.224f, 2.231f, 6.211f, 2.218f, 6.196f, 2.218f)
                curveTo(6.18f, 2.218f, 6.168f, 2.231f, 6.168f, 2.246f)
                curveTo(6.168f, 2.262f, 6.18f, 2.274f, 6.196f, 2.274f)
                close()
                moveTo(5.29f, 3.18f)
                curveTo(5.305f, 3.18f, 5.318f, 3.168f, 5.318f, 3.152f)
                curveTo(5.318f, 3.137f, 5.305f, 3.124f, 5.29f, 3.124f)
                curveTo(5.274f, 3.124f, 5.262f, 3.137f, 5.262f, 3.152f)
                curveTo(5.262f, 3.168f, 5.274f, 3.18f, 5.29f, 3.18f)
                close()
                moveTo(5.38f, 3.361f)
                curveTo(5.396f, 3.361f, 5.409f, 3.349f, 5.409f, 3.333f)
                curveTo(5.409f, 3.318f, 5.396f, 3.305f, 5.38f, 3.305f)
                curveTo(5.365f, 3.305f, 5.352f, 3.318f, 5.352f, 3.333f)
                curveTo(5.352f, 3.349f, 5.365f, 3.361f, 5.38f, 3.361f)
                close()
                moveTo(5.471f, 3.543f)
                curveTo(5.487f, 3.543f, 5.499f, 3.53f, 5.499f, 3.514f)
                curveTo(5.499f, 3.499f, 5.487f, 3.486f, 5.471f, 3.486f)
                curveTo(5.456f, 3.486f, 5.443f, 3.499f, 5.443f, 3.514f)
                curveTo(5.443f, 3.53f, 5.456f, 3.543f, 5.471f, 3.543f)
                close()
                moveTo(9.457f, 3.814f)
                curveTo(9.472f, 3.814f, 9.485f, 3.802f, 9.485f, 3.786f)
                curveTo(9.485f, 3.771f, 9.472f, 3.758f, 9.457f, 3.758f)
                curveTo(9.441f, 3.758f, 9.428f, 3.771f, 9.428f, 3.786f)
                curveTo(9.428f, 3.802f, 9.441f, 3.814f, 9.457f, 3.814f)
                close()
                moveTo(9.303f, 3.786f)
                curveTo(9.303f, 3.871f, 9.372f, 3.939f, 9.457f, 3.939f)
                curveTo(9.541f, 3.939f, 9.61f, 3.871f, 9.61f, 3.786f)
                curveTo(9.61f, 3.738f, 9.588f, 3.696f, 9.553f, 3.667f)
                curveTo(9.635f, 3.664f, 9.7f, 3.597f, 9.7f, 3.514f)
                curveTo(9.7f, 3.501f, 9.698f, 3.488f, 9.695f, 3.475f)
                curveTo(9.751f, 3.453f, 9.791f, 3.398f, 9.791f, 3.333f)
                curveTo(9.791f, 3.32f, 9.789f, 3.307f, 9.786f, 3.294f)
                curveTo(9.842f, 3.271f, 9.881f, 3.216f, 9.881f, 3.152f)
                curveTo(9.881f, 3.068f, 9.813f, 2.999f, 9.728f, 2.999f)
                curveTo(9.718f, 2.999f, 9.707f, 3f, 9.697f, 3.002f)
                curveTo(9.699f, 2.992f, 9.7f, 2.982f, 9.7f, 2.971f)
                curveTo(9.7f, 2.886f, 9.632f, 2.818f, 9.547f, 2.818f)
                curveTo(9.538f, 2.818f, 9.528f, 2.819f, 9.519f, 2.82f)
                curveTo(9.518f, 2.737f, 9.45f, 2.67f, 9.366f, 2.67f)
                curveTo(9.356f, 2.67f, 9.345f, 2.671f, 9.336f, 2.673f)
                curveTo(9.323f, 2.601f, 9.26f, 2.546f, 9.185f, 2.546f)
                curveTo(9.16f, 2.546f, 9.137f, 2.552f, 9.116f, 2.562f)
                curveTo(9.096f, 2.501f, 9.039f, 2.457f, 8.971f, 2.457f)
                curveTo(8.938f, 2.457f, 8.907f, 2.468f, 8.882f, 2.486f)
                curveTo(8.867f, 2.417f, 8.805f, 2.365f, 8.732f, 2.365f)
                curveTo(8.683f, 2.365f, 8.64f, 2.388f, 8.611f, 2.424f)
                curveTo(8.6f, 2.35f, 8.537f, 2.294f, 8.46f, 2.294f)
                curveTo(8.412f, 2.294f, 8.369f, 2.316f, 8.341f, 2.351f)
                curveTo(8.341f, 2.346f, 8.342f, 2.342f, 8.342f, 2.337f)
                curveTo(8.342f, 2.252f, 8.273f, 2.184f, 8.188f, 2.184f)
                curveTo(8.151f, 2.184f, 8.118f, 2.197f, 8.091f, 2.219f)
                curveTo(8.064f, 2.177f, 8.016f, 2.149f, 7.963f, 2.149f)
                curveTo(7.929f, 2.149f, 7.898f, 2.16f, 7.872f, 2.178f)
                curveTo(7.847f, 2.128f, 7.795f, 2.093f, 7.736f, 2.093f)
                curveTo(7.651f, 2.093f, 7.582f, 2.162f, 7.582f, 2.246f)
                curveTo(7.582f, 2.331f, 7.651f, 2.399f, 7.736f, 2.399f)
                curveTo(7.769f, 2.399f, 7.8f, 2.389f, 7.826f, 2.37f)
                curveTo(7.851f, 2.42f, 7.903f, 2.455f, 7.963f, 2.455f)
                curveTo(7.999f, 2.455f, 8.033f, 2.442f, 8.06f, 2.42f)
                curveTo(8.087f, 2.462f, 8.134f, 2.49f, 8.188f, 2.49f)
                curveTo(8.237f, 2.49f, 8.28f, 2.468f, 8.308f, 2.433f)
                curveTo(8.307f, 2.438f, 8.307f, 2.442f, 8.307f, 2.447f)
                curveTo(8.307f, 2.531f, 8.376f, 2.6f, 8.46f, 2.6f)
                curveTo(8.509f, 2.6f, 8.553f, 2.577f, 8.581f, 2.541f)
                curveTo(8.584f, 2.566f, 8.594f, 2.589f, 8.608f, 2.609f)
                curveTo(8.59f, 2.634f, 8.579f, 2.665f, 8.579f, 2.699f)
                curveTo(8.579f, 2.733f, 8.59f, 2.764f, 8.608f, 2.79f)
                curveTo(8.59f, 2.815f, 8.579f, 2.847f, 8.579f, 2.88f)
                curveTo(8.579f, 2.928f, 8.601f, 2.971f, 8.635f, 2.999f)
                curveTo(8.554f, 3.002f, 8.488f, 3.07f, 8.488f, 3.152f)
                curveTo(8.488f, 3.166f, 8.49f, 3.179f, 8.493f, 3.191f)
                curveTo(8.437f, 3.214f, 8.398f, 3.269f, 8.398f, 3.333f)
                curveTo(8.398f, 3.347f, 8.399f, 3.36f, 8.403f, 3.373f)
                curveTo(8.347f, 3.395f, 8.307f, 3.45f, 8.307f, 3.514f)
                curveTo(8.307f, 3.599f, 8.376f, 3.668f, 8.46f, 3.668f)
                curveTo(8.545f, 3.668f, 8.613f, 3.599f, 8.613f, 3.514f)
                curveTo(8.613f, 3.501f, 8.611f, 3.488f, 8.608f, 3.475f)
                curveTo(8.664f, 3.453f, 8.704f, 3.398f, 8.704f, 3.333f)
                curveTo(8.704f, 3.32f, 8.702f, 3.307f, 8.699f, 3.294f)
                curveTo(8.755f, 3.271f, 8.794f, 3.216f, 8.794f, 3.152f)
                curveTo(8.794f, 3.104f, 8.772f, 3.061f, 8.738f, 3.033f)
                curveTo(8.82f, 3.03f, 8.885f, 2.963f, 8.885f, 2.88f)
                curveTo(8.885f, 2.847f, 8.874f, 2.815f, 8.855f, 2.79f)
                curveTo(8.867f, 2.773f, 8.876f, 2.755f, 8.881f, 2.734f)
                curveTo(8.906f, 2.752f, 8.937f, 2.763f, 8.971f, 2.763f)
                curveTo(8.995f, 2.763f, 9.019f, 2.757f, 9.039f, 2.747f)
                curveTo(9.059f, 2.808f, 9.117f, 2.852f, 9.185f, 2.852f)
                curveTo(9.195f, 2.852f, 9.205f, 2.851f, 9.215f, 2.849f)
                curveTo(9.228f, 2.921f, 9.29f, 2.976f, 9.366f, 2.976f)
                curveTo(9.376f, 2.976f, 9.385f, 2.975f, 9.394f, 2.973f)
                curveTo(9.395f, 3.057f, 9.463f, 3.124f, 9.547f, 3.124f)
                curveTo(9.558f, 3.124f, 9.568f, 3.123f, 9.578f, 3.121f)
                curveTo(9.576f, 3.131f, 9.575f, 3.141f, 9.575f, 3.152f)
                curveTo(9.575f, 3.166f, 9.577f, 3.179f, 9.58f, 3.191f)
                curveTo(9.524f, 3.214f, 9.485f, 3.269f, 9.485f, 3.333f)
                curveTo(9.485f, 3.347f, 9.486f, 3.36f, 9.49f, 3.373f)
                curveTo(9.434f, 3.395f, 9.394f, 3.45f, 9.394f, 3.514f)
                curveTo(9.394f, 3.562f, 9.416f, 3.605f, 9.451f, 3.633f)
                curveTo(9.369f, 3.636f, 9.303f, 3.704f, 9.303f, 3.786f)
                close()
                moveTo(8.821f, 2.642f)
                curveTo(8.796f, 2.661f, 8.765f, 2.671f, 8.732f, 2.671f)
                curveTo(8.681f, 2.671f, 8.636f, 2.647f, 8.608f, 2.609f)
                curveTo(8.636f, 2.571f, 8.681f, 2.546f, 8.732f, 2.546f)
                curveTo(8.765f, 2.546f, 8.797f, 2.557f, 8.822f, 2.575f)
                curveTo(8.819f, 2.587f, 8.818f, 2.598f, 8.818f, 2.61f)
                curveTo(8.818f, 2.621f, 8.819f, 2.632f, 8.821f, 2.642f)
                close()
                moveTo(8.855f, 2.609f)
                curveTo(8.874f, 2.634f, 8.885f, 2.665f, 8.885f, 2.699f)
                curveTo(8.885f, 2.711f, 8.884f, 2.723f, 8.881f, 2.734f)
                curveTo(8.851f, 2.712f, 8.829f, 2.68f, 8.821f, 2.642f)
                curveTo(8.834f, 2.633f, 8.846f, 2.622f, 8.855f, 2.609f)
                close()
                moveTo(8.855f, 2.609f)
                curveTo(8.846f, 2.596f, 8.835f, 2.585f, 8.822f, 2.575f)
                curveTo(8.83f, 2.539f, 8.852f, 2.507f, 8.882f, 2.486f)
                curveTo(8.884f, 2.496f, 8.885f, 2.507f, 8.885f, 2.518f)
                curveTo(8.885f, 2.552f, 8.874f, 2.583f, 8.855f, 2.609f)
                close()
                moveTo(8.732f, 2.546f)
                curveTo(8.716f, 2.546f, 8.704f, 2.534f, 8.704f, 2.518f)
                curveTo(8.704f, 2.503f, 8.716f, 2.49f, 8.732f, 2.49f)
                curveTo(8.747f, 2.49f, 8.76f, 2.503f, 8.76f, 2.518f)
                curveTo(8.76f, 2.534f, 8.747f, 2.546f, 8.732f, 2.546f)
                close()
                moveTo(8.732f, 2.852f)
                curveTo(8.681f, 2.852f, 8.636f, 2.828f, 8.608f, 2.79f)
                curveTo(8.636f, 2.752f, 8.681f, 2.727f, 8.732f, 2.727f)
                curveTo(8.783f, 2.727f, 8.827f, 2.752f, 8.855f, 2.79f)
                curveTo(8.827f, 2.828f, 8.783f, 2.852f, 8.732f, 2.852f)
                close()
                moveTo(8.732f, 2.852f)
                curveTo(8.747f, 2.852f, 8.76f, 2.865f, 8.76f, 2.88f)
                curveTo(8.76f, 2.896f, 8.747f, 2.909f, 8.732f, 2.909f)
                curveTo(8.716f, 2.909f, 8.704f, 2.896f, 8.704f, 2.88f)
                curveTo(8.704f, 2.865f, 8.716f, 2.852f, 8.732f, 2.852f)
                close()
                moveTo(8.732f, 2.727f)
                curveTo(8.716f, 2.727f, 8.704f, 2.715f, 8.704f, 2.699f)
                curveTo(8.704f, 2.684f, 8.716f, 2.671f, 8.732f, 2.671f)
                curveTo(8.747f, 2.671f, 8.76f, 2.684f, 8.76f, 2.699f)
                curveTo(8.76f, 2.715f, 8.747f, 2.727f, 8.732f, 2.727f)
                close()
                moveTo(8.608f, 3.475f)
                curveTo(8.591f, 3.41f, 8.531f, 3.361f, 8.46f, 3.361f)
                curveTo(8.44f, 3.361f, 8.42f, 3.365f, 8.403f, 3.373f)
                curveTo(8.42f, 3.438f, 8.48f, 3.486f, 8.551f, 3.486f)
                curveTo(8.571f, 3.486f, 8.59f, 3.482f, 8.608f, 3.475f)
                close()
                moveTo(8.699f, 3.294f)
                curveTo(8.681f, 3.229f, 8.622f, 3.18f, 8.551f, 3.18f)
                curveTo(8.53f, 3.18f, 8.511f, 3.184f, 8.493f, 3.191f)
                curveTo(8.511f, 3.257f, 8.57f, 3.305f, 8.641f, 3.305f)
                curveTo(8.662f, 3.305f, 8.681f, 3.301f, 8.699f, 3.294f)
                close()
                moveTo(8.738f, 3.033f)
                curveTo(8.712f, 3.012f, 8.678f, 2.999f, 8.641f, 2.999f)
                lineTo(8.635f, 2.999f)
                curveTo(8.662f, 3.021f, 8.695f, 3.034f, 8.732f, 3.034f)
                lineTo(8.738f, 3.033f)
                close()
                moveTo(7.826f, 2.37f)
                curveTo(7.864f, 2.342f, 7.889f, 2.297f, 7.889f, 2.246f)
                curveTo(7.889f, 2.222f, 7.883f, 2.199f, 7.872f, 2.178f)
                curveTo(7.834f, 2.206f, 7.809f, 2.251f, 7.809f, 2.302f)
                curveTo(7.809f, 2.326f, 7.815f, 2.35f, 7.826f, 2.37f)
                close()
                moveTo(8.06f, 2.42f)
                curveTo(8.094f, 2.392f, 8.116f, 2.349f, 8.116f, 2.302f)
                curveTo(8.116f, 2.271f, 8.107f, 2.243f, 8.091f, 2.219f)
                curveTo(8.057f, 2.247f, 8.035f, 2.289f, 8.035f, 2.337f)
                curveTo(8.035f, 2.368f, 8.044f, 2.396f, 8.06f, 2.42f)
                close()
                moveTo(8.341f, 2.351f)
                curveTo(8.338f, 2.382f, 8.326f, 2.41f, 8.308f, 2.433f)
                curveTo(8.311f, 2.402f, 8.322f, 2.374f, 8.341f, 2.351f)
                close()
                moveTo(8.581f, 2.541f)
                curveTo(8.601f, 2.515f, 8.613f, 2.483f, 8.613f, 2.447f)
                curveTo(8.613f, 2.439f, 8.613f, 2.431f, 8.611f, 2.424f)
                curveTo(8.591f, 2.45f, 8.579f, 2.482f, 8.579f, 2.518f)
                curveTo(8.579f, 2.526f, 8.579f, 2.534f, 8.581f, 2.541f)
                close()
                moveTo(9.039f, 2.747f)
                curveTo(9.09f, 2.722f, 9.124f, 2.67f, 9.124f, 2.61f)
                curveTo(9.124f, 2.593f, 9.121f, 2.577f, 9.116f, 2.562f)
                curveTo(9.066f, 2.587f, 9.032f, 2.639f, 9.032f, 2.699f)
                curveTo(9.032f, 2.716f, 9.034f, 2.732f, 9.039f, 2.747f)
                close()
                moveTo(9.215f, 2.849f)
                curveTo(9.285f, 2.835f, 9.338f, 2.773f, 9.338f, 2.699f)
                curveTo(9.338f, 2.69f, 9.337f, 2.681f, 9.336f, 2.673f)
                curveTo(9.266f, 2.687f, 9.213f, 2.749f, 9.213f, 2.823f)
                curveTo(9.213f, 2.832f, 9.214f, 2.841f, 9.215f, 2.849f)
                close()
                moveTo(9.578f, 3.121f)
                curveTo(9.638f, 3.109f, 9.685f, 3.062f, 9.697f, 3.002f)
                curveTo(9.638f, 3.015f, 9.591f, 3.061f, 9.578f, 3.121f)
                close()
                moveTo(9.519f, 2.82f)
                lineTo(9.519f, 2.823f)
                curveTo(9.519f, 2.898f, 9.465f, 2.96f, 9.394f, 2.973f)
                lineTo(9.394f, 2.971f)
                curveTo(9.394f, 2.896f, 9.448f, 2.834f, 9.519f, 2.82f)
                close()
                moveTo(9.58f, 3.191f)
                curveTo(9.598f, 3.184f, 9.617f, 3.18f, 9.638f, 3.18f)
                curveTo(9.709f, 3.18f, 9.768f, 3.229f, 9.786f, 3.294f)
                curveTo(9.768f, 3.301f, 9.749f, 3.305f, 9.728f, 3.305f)
                curveTo(9.657f, 3.305f, 9.598f, 3.257f, 9.58f, 3.191f)
                close()
                moveTo(9.49f, 3.373f)
                curveTo(9.507f, 3.365f, 9.527f, 3.361f, 9.547f, 3.361f)
                curveTo(9.618f, 3.361f, 9.678f, 3.41f, 9.695f, 3.475f)
                curveTo(9.677f, 3.482f, 9.658f, 3.486f, 9.638f, 3.486f)
                curveTo(9.567f, 3.486f, 9.507f, 3.438f, 9.49f, 3.373f)
                close()
                moveTo(9.547f, 3.668f)
                curveTo(9.51f, 3.668f, 9.477f, 3.655f, 9.451f, 3.633f)
                lineTo(9.457f, 3.633f)
                curveTo(9.493f, 3.633f, 9.527f, 3.646f, 9.553f, 3.667f)
                lineTo(9.547f, 3.668f)
                close()
                moveTo(9.547f, 3.543f)
                curveTo(9.563f, 3.543f, 9.575f, 3.53f, 9.575f, 3.514f)
                curveTo(9.575f, 3.499f, 9.563f, 3.486f, 9.547f, 3.486f)
                curveTo(9.532f, 3.486f, 9.519f, 3.499f, 9.519f, 3.514f)
                curveTo(9.519f, 3.53f, 9.532f, 3.543f, 9.547f, 3.543f)
                close()
                moveTo(9.638f, 3.361f)
                curveTo(9.653f, 3.361f, 9.666f, 3.349f, 9.666f, 3.333f)
                curveTo(9.666f, 3.318f, 9.653f, 3.305f, 9.638f, 3.305f)
                curveTo(9.622f, 3.305f, 9.61f, 3.318f, 9.61f, 3.333f)
                curveTo(9.61f, 3.349f, 9.622f, 3.361f, 9.638f, 3.361f)
                close()
                moveTo(9.728f, 3.18f)
                curveTo(9.744f, 3.18f, 9.756f, 3.168f, 9.756f, 3.152f)
                curveTo(9.756f, 3.137f, 9.744f, 3.124f, 9.728f, 3.124f)
                curveTo(9.713f, 3.124f, 9.7f, 3.137f, 9.7f, 3.152f)
                curveTo(9.7f, 3.168f, 9.713f, 3.18f, 9.728f, 3.18f)
                close()
                moveTo(9.547f, 2.999f)
                curveTo(9.563f, 2.999f, 9.575f, 2.987f, 9.575f, 2.971f)
                curveTo(9.575f, 2.955f, 9.563f, 2.943f, 9.547f, 2.943f)
                curveTo(9.532f, 2.943f, 9.519f, 2.955f, 9.519f, 2.971f)
                curveTo(9.519f, 2.987f, 9.532f, 2.999f, 9.547f, 2.999f)
                close()
                moveTo(9.366f, 2.851f)
                curveTo(9.381f, 2.851f, 9.394f, 2.838f, 9.394f, 2.823f)
                curveTo(9.394f, 2.807f, 9.381f, 2.795f, 9.366f, 2.795f)
                curveTo(9.35f, 2.795f, 9.338f, 2.807f, 9.338f, 2.823f)
                curveTo(9.338f, 2.838f, 9.35f, 2.851f, 9.366f, 2.851f)
                close()
                moveTo(9.185f, 2.727f)
                curveTo(9.2f, 2.727f, 9.213f, 2.715f, 9.213f, 2.699f)
                curveTo(9.213f, 2.684f, 9.2f, 2.671f, 9.185f, 2.671f)
                curveTo(9.169f, 2.671f, 9.157f, 2.684f, 9.157f, 2.699f)
                curveTo(9.157f, 2.715f, 9.169f, 2.727f, 9.185f, 2.727f)
                close()
                moveTo(8.971f, 2.638f)
                curveTo(8.986f, 2.638f, 8.999f, 2.626f, 8.999f, 2.61f)
                curveTo(8.999f, 2.595f, 8.986f, 2.582f, 8.971f, 2.582f)
                curveTo(8.955f, 2.582f, 8.943f, 2.595f, 8.943f, 2.61f)
                curveTo(8.943f, 2.626f, 8.955f, 2.638f, 8.971f, 2.638f)
                close()
                moveTo(8.46f, 2.475f)
                curveTo(8.476f, 2.475f, 8.488f, 2.462f, 8.488f, 2.447f)
                curveTo(8.488f, 2.431f, 8.476f, 2.419f, 8.46f, 2.419f)
                curveTo(8.445f, 2.419f, 8.432f, 2.431f, 8.432f, 2.447f)
                curveTo(8.432f, 2.462f, 8.445f, 2.475f, 8.46f, 2.475f)
                close()
                moveTo(8.188f, 2.365f)
                curveTo(8.204f, 2.365f, 8.217f, 2.352f, 8.217f, 2.337f)
                curveTo(8.217f, 2.321f, 8.204f, 2.309f, 8.188f, 2.309f)
                curveTo(8.173f, 2.309f, 8.16f, 2.321f, 8.16f, 2.337f)
                curveTo(8.16f, 2.352f, 8.173f, 2.365f, 8.188f, 2.365f)
                close()
                moveTo(7.963f, 2.33f)
                curveTo(7.978f, 2.33f, 7.991f, 2.317f, 7.991f, 2.302f)
                curveTo(7.991f, 2.286f, 7.978f, 2.274f, 7.963f, 2.274f)
                curveTo(7.947f, 2.274f, 7.934f, 2.286f, 7.934f, 2.302f)
                curveTo(7.934f, 2.317f, 7.947f, 2.33f, 7.963f, 2.33f)
                close()
                moveTo(7.736f, 2.274f)
                curveTo(7.751f, 2.274f, 7.764f, 2.262f, 7.764f, 2.246f)
                curveTo(7.764f, 2.231f, 7.751f, 2.218f, 7.736f, 2.218f)
                curveTo(7.72f, 2.218f, 7.707f, 2.231f, 7.707f, 2.246f)
                curveTo(7.707f, 2.262f, 7.72f, 2.274f, 7.736f, 2.274f)
                close()
                moveTo(8.641f, 3.18f)
                curveTo(8.657f, 3.18f, 8.669f, 3.168f, 8.669f, 3.152f)
                curveTo(8.669f, 3.137f, 8.657f, 3.124f, 8.641f, 3.124f)
                curveTo(8.626f, 3.124f, 8.613f, 3.137f, 8.613f, 3.152f)
                curveTo(8.613f, 3.168f, 8.626f, 3.18f, 8.641f, 3.18f)
                close()
                moveTo(8.551f, 3.361f)
                curveTo(8.566f, 3.361f, 8.579f, 3.349f, 8.579f, 3.333f)
                curveTo(8.579f, 3.318f, 8.566f, 3.305f, 8.551f, 3.305f)
                curveTo(8.535f, 3.305f, 8.523f, 3.318f, 8.523f, 3.333f)
                curveTo(8.523f, 3.349f, 8.535f, 3.361f, 8.551f, 3.361f)
                close()
                moveTo(8.46f, 3.543f)
                curveTo(8.476f, 3.543f, 8.488f, 3.53f, 8.488f, 3.514f)
                curveTo(8.488f, 3.499f, 8.476f, 3.486f, 8.46f, 3.486f)
                curveTo(8.445f, 3.486f, 8.432f, 3.499f, 8.432f, 3.514f)
                curveTo(8.432f, 3.53f, 8.445f, 3.543f, 8.46f, 3.543f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF6C540)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.939f, 1.346f)
                lineTo(6.804f, 1.349f)
                lineTo(6.805f, 1.569f)
                lineTo(6.557f, 1.569f)
                lineTo(6.56f, 1.703f)
                lineTo(6.805f, 1.703f)
                lineTo(6.805f, 1.955f)
                lineTo(6.939f, 1.953f)
                lineTo(6.939f, 1.703f)
                lineTo(7.183f, 1.703f)
                lineTo(7.18f, 1.569f)
                lineTo(6.939f, 1.569f)
                lineTo(6.939f, 1.346f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.615f, 5.459f)
                horizontalLineTo(10.116f)
                verticalLineTo(10.98f)
                curveTo(10.116f, 10.98f, 9.919f, 13.73f, 6.865f, 13.73f)
                curveTo(3.812f, 13.73f, 3.615f, 10.98f, 3.615f, 10.98f)
                verticalLineTo(5.459f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.577f, 5.65f)
                curveTo(5.518f, 5.65f, 5.426f, 5.693f, 5.304f, 5.741f)
                curveTo(5.183f, 5.79f, 5.055f, 5.894f, 5.18f, 5.999f)
                curveTo(5.304f, 6.104f, 5.483f, 6.334f, 5.483f, 6.248f)
                curveTo(5.483f, 6.162f, 5.696f, 6.079f, 5.696f, 6.12f)
                curveTo(5.696f, 6.162f, 5.63f, 6.248f, 5.803f, 6.248f)
                curveTo(5.976f, 6.248f, 6.065f, 6.299f, 5.881f, 6.299f)
                curveTo(5.696f, 6.299f, 5.676f, 6.384f, 5.556f, 6.384f)
                curveTo(5.436f, 6.384f, 5.18f, 6.299f, 5.18f, 6.248f)
                curveTo(5.18f, 6.198f, 5.328f, 6.496f, 5.483f, 6.496f)
                curveTo(5.638f, 6.496f, 5.725f, 6.642f, 5.803f, 6.569f)
                curveTo(5.881f, 6.496f, 5.872f, 6.496f, 5.997f, 6.496f)
                curveTo(6.122f, 6.496f, 6.076f, 6.203f, 6.076f, 6.203f)
                curveTo(6.076f, 6.203f, 5.637f, 5.65f, 5.577f, 5.65f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.086f, 5.65f)
                curveTo(8.145f, 5.65f, 8.237f, 5.693f, 8.359f, 5.741f)
                curveTo(8.48f, 5.79f, 8.608f, 5.894f, 8.483f, 5.999f)
                curveTo(8.359f, 6.104f, 8.18f, 6.334f, 8.18f, 6.248f)
                curveTo(8.18f, 6.162f, 7.967f, 6.079f, 7.967f, 6.12f)
                curveTo(7.967f, 6.162f, 8.033f, 6.248f, 7.86f, 6.248f)
                curveTo(7.687f, 6.248f, 7.597f, 6.299f, 7.782f, 6.299f)
                curveTo(7.967f, 6.299f, 7.987f, 6.384f, 8.107f, 6.384f)
                curveTo(8.227f, 6.384f, 8.483f, 6.299f, 8.483f, 6.248f)
                curveTo(8.483f, 6.198f, 8.335f, 6.496f, 8.18f, 6.496f)
                curveTo(8.025f, 6.496f, 7.937f, 6.642f, 7.86f, 6.569f)
                curveTo(7.782f, 6.496f, 7.791f, 6.496f, 7.666f, 6.496f)
                curveTo(7.541f, 6.496f, 7.586f, 6.203f, 7.586f, 6.203f)
                curveTo(7.586f, 6.203f, 8.026f, 5.65f, 8.086f, 5.65f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.882f, 6.25f)
                curveTo(9.007f, 6.541f, 8.052f, 7.62f, 8.052f, 7.62f)
                horizontalLineTo(7.945f)
                curveTo(7.9f, 7.62f, 7.817f, 7.51f, 7.716f, 7.376f)
                curveTo(7.647f, 7.285f, 7.569f, 7.182f, 7.491f, 7.097f)
                curveTo(7.343f, 6.938f, 7.421f, 6.804f, 7.494f, 6.679f)
                curveTo(7.517f, 6.64f, 7.539f, 6.603f, 7.553f, 6.566f)
                curveTo(7.585f, 6.485f, 7.59f, 6.453f, 7.595f, 6.417f)
                curveTo(7.6f, 6.381f, 7.606f, 6.342f, 7.637f, 6.25f)
                curveTo(7.683f, 6.116f, 7.843f, 5.943f, 7.955f, 5.822f)
                curveTo(7.998f, 5.776f, 8.033f, 5.738f, 8.052f, 5.712f)
                curveTo(8.112f, 5.633f, 8.066f, 5.633f, 7.942f, 5.634f)
                curveTo(7.925f, 5.635f, 7.907f, 5.635f, 7.887f, 5.635f)
                curveTo(7.721f, 5.635f, 7.405f, 5.712f, 7.31f, 5.803f)
                curveTo(7.216f, 5.894f, 7.117f, 5.913f, 6.971f, 5.913f)
                curveTo(6.825f, 5.913f, 6.915f, 6.011f, 7.048f, 6.077f)
                curveTo(6.905f, 6.105f, 6.813f, 6.343f, 6.76f, 6.554f)
                curveTo(6.73f, 6.343f, 6.665f, 6.105f, 6.523f, 6.077f)
                curveTo(6.655f, 6.011f, 6.745f, 5.913f, 6.599f, 5.913f)
                curveTo(6.454f, 5.913f, 6.355f, 5.894f, 6.26f, 5.803f)
                curveTo(6.166f, 5.712f, 5.849f, 5.635f, 5.684f, 5.635f)
                curveTo(5.664f, 5.635f, 5.645f, 5.635f, 5.628f, 5.634f)
                curveTo(5.504f, 5.633f, 5.459f, 5.633f, 5.518f, 5.712f)
                curveTo(5.537f, 5.738f, 5.573f, 5.776f, 5.616f, 5.822f)
                curveTo(5.727f, 5.943f, 5.887f, 6.116f, 5.933f, 6.25f)
                curveTo(5.965f, 6.342f, 5.97f, 6.381f, 5.975f, 6.417f)
                curveTo(5.981f, 6.453f, 5.985f, 6.485f, 6.017f, 6.566f)
                curveTo(6.032f, 6.603f, 6.054f, 6.64f, 6.076f, 6.679f)
                curveTo(6.149f, 6.804f, 6.227f, 6.938f, 6.08f, 7.097f)
                curveTo(6.001f, 7.182f, 5.924f, 7.285f, 5.855f, 7.376f)
                curveTo(5.754f, 7.51f, 5.67f, 7.62f, 5.625f, 7.62f)
                horizontalLineTo(5.518f)
                curveTo(5.518f, 7.62f, 4.563f, 6.541f, 4.688f, 6.25f)
                curveTo(4.736f, 6.138f, 4.814f, 6.032f, 4.878f, 5.944f)
                curveTo(4.98f, 5.805f, 5.048f, 5.712f, 4.911f, 5.712f)
                curveTo(4.688f, 5.712f, 3.797f, 6.277f, 3.797f, 7.55f)
                curveTo(3.797f, 8.824f, 3.88f, 9.548f, 4.071f, 10.055f)
                curveTo(4.201f, 10.401f, 4.081f, 10.738f, 3.993f, 10.988f)
                curveTo(3.951f, 11.105f, 3.916f, 11.203f, 3.916f, 11.275f)
                curveTo(3.916f, 11.501f, 4.267f, 11.303f, 4.267f, 11.161f)
                curveTo(4.267f, 11.094f, 4.315f, 11.194f, 4.365f, 11.299f)
                curveTo(4.421f, 11.415f, 4.479f, 11.537f, 4.479f, 11.447f)
                curveTo(4.479f, 11.351f, 4.535f, 11.249f, 4.584f, 11.159f)
                curveTo(4.623f, 11.088f, 4.658f, 11.025f, 4.658f, 10.978f)
                curveTo(4.658f, 10.931f, 4.707f, 10.933f, 4.762f, 10.935f)
                curveTo(4.832f, 10.937f, 4.911f, 10.94f, 4.911f, 10.844f)
                curveTo(4.911f, 10.779f, 4.937f, 10.766f, 4.968f, 10.75f)
                curveTo(5.02f, 10.723f, 5.088f, 10.688f, 5.088f, 10.396f)
                curveTo(5.088f, 10.179f, 5.132f, 10.256f, 5.181f, 10.344f)
                curveTo(5.227f, 10.425f, 5.278f, 10.515f, 5.306f, 10.396f)
                curveTo(5.309f, 10.384f, 5.337f, 10.334f, 5.373f, 10.272f)
                curveTo(5.424f, 10.182f, 5.49f, 10.066f, 5.511f, 10.008f)
                curveTo(5.446f, 10.263f, 5.29f, 10.528f, 5.191f, 10.655f)
                curveTo(5.088f, 10.786f, 4.911f, 11.07f, 4.911f, 11.07f)
                curveTo(4.911f, 11.07f, 5.077f, 11.163f, 5.191f, 11.07f)
                curveTo(5.255f, 11.019f, 5.26f, 11.067f, 5.264f, 11.12f)
                curveTo(5.268f, 11.162f, 5.272f, 11.206f, 5.306f, 11.206f)
                curveTo(5.327f, 11.206f, 5.347f, 11.21f, 5.365f, 11.213f)
                curveTo(5.378f, 11.215f, 5.39f, 11.217f, 5.401f, 11.217f)
                curveTo(5.362f, 11.315f, 5.328f, 11.471f, 5.443f, 11.367f)
                curveTo(5.526f, 11.292f, 5.583f, 11.262f, 5.621f, 11.242f)
                curveTo(5.666f, 11.219f, 5.684f, 11.21f, 5.684f, 11.161f)
                curveTo(5.684f, 11.112f, 5.702f, 11.129f, 5.73f, 11.155f)
                curveTo(5.754f, 11.177f, 5.786f, 11.206f, 5.821f, 11.206f)
                curveTo(5.866f, 11.206f, 5.875f, 11.144f, 5.889f, 11.054f)
                curveTo(5.898f, 10.993f, 5.909f, 10.92f, 5.933f, 10.844f)
                curveTo(5.939f, 10.826f, 5.945f, 10.809f, 5.95f, 10.793f)
                curveTo(6f, 10.637f, 6.023f, 10.564f, 6.08f, 10.761f)
                curveTo(6.106f, 10.853f, 6.153f, 10.918f, 6.194f, 10.975f)
                curveTo(6.249f, 11.052f, 6.293f, 11.114f, 6.26f, 11.206f)
                curveTo(6.247f, 11.243f, 6.231f, 11.283f, 6.213f, 11.327f)
                curveTo(6.153f, 11.478f, 6.08f, 11.662f, 6.08f, 11.807f)
                curveTo(6.08f, 11.894f, 6.001f, 12.011f, 5.927f, 12.122f)
                curveTo(5.841f, 12.252f, 5.76f, 12.372f, 5.821f, 12.42f)
                curveTo(5.933f, 12.509f, 5.797f, 12.811f, 5.684f, 12.965f)
                curveTo(5.57f, 13.12f, 5.589f, 13.309f, 5.761f, 13.309f)
                curveTo(5.855f, 13.309f, 5.907f, 13.343f, 5.953f, 13.374f)
                curveTo(5.991f, 13.4f, 6.026f, 13.423f, 6.08f, 13.423f)
                curveTo(6.198f, 13.423f, 6.26f, 13.365f, 6.26f, 13.365f)
                curveTo(6.26f, 13.365f, 6.333f, 13.475f, 6.454f, 13.475f)
                curveTo(6.575f, 13.475f, 6.599f, 13.365f, 6.599f, 13.365f)
                lineTo(6.689f, 13.475f)
                lineTo(6.696f, 12.993f)
                verticalLineTo(13.475f)
                lineTo(6.971f, 13.365f)
                curveTo(6.971f, 13.365f, 6.996f, 13.475f, 7.117f, 13.475f)
                curveTo(7.237f, 13.475f, 7.31f, 13.365f, 7.31f, 13.365f)
                curveTo(7.31f, 13.365f, 7.373f, 13.423f, 7.491f, 13.423f)
                curveTo(7.544f, 13.423f, 7.579f, 13.4f, 7.617f, 13.374f)
                curveTo(7.664f, 13.343f, 7.715f, 13.309f, 7.809f, 13.309f)
                curveTo(7.981f, 13.309f, 8f, 13.12f, 7.887f, 12.965f)
                curveTo(7.773f, 12.811f, 7.637f, 12.509f, 7.749f, 12.42f)
                curveTo(7.81f, 12.372f, 7.73f, 12.252f, 7.643f, 12.122f)
                curveTo(7.569f, 12.011f, 7.491f, 11.894f, 7.491f, 11.807f)
                curveTo(7.491f, 11.662f, 7.417f, 11.478f, 7.357f, 11.327f)
                curveTo(7.34f, 11.283f, 7.323f, 11.243f, 7.31f, 11.206f)
                curveTo(7.277f, 11.114f, 7.321f, 11.052f, 7.377f, 10.975f)
                curveTo(7.417f, 10.918f, 7.464f, 10.853f, 7.491f, 10.761f)
                curveTo(7.547f, 10.564f, 7.571f, 10.637f, 7.621f, 10.793f)
                curveTo(7.626f, 10.809f, 7.631f, 10.826f, 7.637f, 10.844f)
                curveTo(7.662f, 10.92f, 7.673f, 10.993f, 7.682f, 11.054f)
                curveTo(7.695f, 11.144f, 7.705f, 11.206f, 7.749f, 11.206f)
                curveTo(7.784f, 11.206f, 7.816f, 11.177f, 7.84f, 11.155f)
                curveTo(7.869f, 11.129f, 7.887f, 11.112f, 7.887f, 11.161f)
                curveTo(7.887f, 11.21f, 7.905f, 11.219f, 7.949f, 11.242f)
                curveTo(7.987f, 11.262f, 8.045f, 11.292f, 8.127f, 11.367f)
                curveTo(8.242f, 11.471f, 8.208f, 11.315f, 8.17f, 11.217f)
                curveTo(8.18f, 11.217f, 8.192f, 11.215f, 8.205f, 11.213f)
                curveTo(8.223f, 11.21f, 8.243f, 11.206f, 8.264f, 11.206f)
                curveTo(8.298f, 11.206f, 8.302f, 11.162f, 8.306f, 11.12f)
                curveTo(8.311f, 11.067f, 8.315f, 11.019f, 8.379f, 11.07f)
                curveTo(8.494f, 11.163f, 8.659f, 11.07f, 8.659f, 11.07f)
                curveTo(8.659f, 11.07f, 8.482f, 10.786f, 8.379f, 10.655f)
                curveTo(8.28f, 10.528f, 8.124f, 10.263f, 8.059f, 10.008f)
                curveTo(8.08f, 10.066f, 8.146f, 10.182f, 8.198f, 10.272f)
                curveTo(8.233f, 10.334f, 8.262f, 10.384f, 8.264f, 10.396f)
                curveTo(8.292f, 10.515f, 8.343f, 10.425f, 8.389f, 10.344f)
                curveTo(8.439f, 10.256f, 8.482f, 10.179f, 8.482f, 10.396f)
                curveTo(8.482f, 10.688f, 8.551f, 10.723f, 8.602f, 10.75f)
                curveTo(8.634f, 10.766f, 8.659f, 10.779f, 8.659f, 10.844f)
                curveTo(8.659f, 10.94f, 8.738f, 10.937f, 8.808f, 10.935f)
                curveTo(8.863f, 10.933f, 8.913f, 10.931f, 8.913f, 10.978f)
                curveTo(8.913f, 11.025f, 8.947f, 11.088f, 8.986f, 11.159f)
                curveTo(9.035f, 11.249f, 9.091f, 11.351f, 9.091f, 11.447f)
                curveTo(9.091f, 11.537f, 9.149f, 11.415f, 9.205f, 11.299f)
                curveTo(9.255f, 11.194f, 9.303f, 11.094f, 9.303f, 11.161f)
                curveTo(9.303f, 11.303f, 9.654f, 11.501f, 9.654f, 11.275f)
                curveTo(9.654f, 11.203f, 9.619f, 11.105f, 9.578f, 10.988f)
                curveTo(9.489f, 10.738f, 9.369f, 10.401f, 9.5f, 10.055f)
                curveTo(9.691f, 9.548f, 9.773f, 8.824f, 9.773f, 7.55f)
                curveTo(9.773f, 6.277f, 8.882f, 5.712f, 8.659f, 5.712f)
                curveTo(8.522f, 5.712f, 8.59f, 5.805f, 8.692f, 5.944f)
                curveTo(8.757f, 6.032f, 8.834f, 6.138f, 8.882f, 6.25f)
                close()
                moveTo(8.052f, 9.98f)
                curveTo(8.054f, 9.99f, 8.057f, 9.999f, 8.059f, 10.008f)
                curveTo(8.055f, 9.996f, 8.052f, 9.987f, 8.052f, 9.98f)
                close()
                moveTo(8.127f, 11.161f)
                curveTo(8.127f, 11.129f, 8.149f, 11.165f, 8.17f, 11.217f)
                curveTo(8.143f, 11.218f, 8.127f, 11.208f, 8.127f, 11.161f)
                close()
                moveTo(5.401f, 11.217f)
                curveTo(5.427f, 11.218f, 5.443f, 11.208f, 5.443f, 11.161f)
                curveTo(5.443f, 11.129f, 5.421f, 11.165f, 5.401f, 11.217f)
                close()
                moveTo(5.511f, 10.008f)
                curveTo(5.516f, 9.996f, 5.518f, 9.987f, 5.518f, 9.98f)
                curveTo(5.516f, 9.99f, 5.514f, 9.999f, 5.511f, 10.008f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.118f, 12.001f)
                curveTo(5.118f, 11.913f, 5.343f, 11.71f, 5.343f, 11.71f)
                verticalLineTo(11.727f)
                curveTo(5.374f, 11.752f, 5.575f, 11.918f, 5.575f, 11.999f)
                curveTo(5.575f, 12.049f, 5.549f, 12.122f, 5.527f, 12.184f)
                curveTo(5.51f, 12.231f, 5.496f, 12.272f, 5.496f, 12.293f)
                curveTo(5.496f, 12.307f, 5.501f, 12.297f, 5.513f, 12.278f)
                curveTo(5.54f, 12.23f, 5.601f, 12.125f, 5.685f, 12.195f)
                curveTo(5.797f, 12.287f, 5.796f, 12.423f, 5.795f, 12.51f)
                curveTo(5.795f, 12.515f, 5.795f, 12.52f, 5.795f, 12.524f)
                curveTo(5.795f, 12.551f, 5.795f, 12.551f, 5.792f, 12.538f)
                curveTo(5.784f, 12.511f, 5.76f, 12.425f, 5.685f, 12.425f)
                curveTo(5.575f, 12.425f, 5.496f, 12.524f, 5.496f, 12.524f)
                verticalLineTo(12.694f)
                curveTo(5.496f, 12.694f, 5.509f, 12.835f, 5.575f, 12.765f)
                curveTo(5.641f, 12.694f, 5.654f, 12.851f, 5.575f, 12.851f)
                curveTo(5.534f, 12.851f, 5.493f, 12.894f, 5.452f, 12.936f)
                curveTo(5.413f, 12.977f, 5.374f, 13.017f, 5.339f, 13.017f)
                verticalLineTo(13.002f)
                curveTo(5.305f, 13f, 5.277f, 12.965f, 5.248f, 12.929f)
                curveTo(5.217f, 12.891f, 5.186f, 12.851f, 5.145f, 12.851f)
                curveTo(5.066f, 12.851f, 5.08f, 12.694f, 5.145f, 12.765f)
                curveTo(5.211f, 12.835f, 5.225f, 12.694f, 5.225f, 12.694f)
                verticalLineTo(12.524f)
                curveTo(5.225f, 12.524f, 5.145f, 12.425f, 5.035f, 12.425f)
                curveTo(4.96f, 12.425f, 4.936f, 12.511f, 4.928f, 12.538f)
                curveTo(4.925f, 12.551f, 4.925f, 12.551f, 4.925f, 12.524f)
                curveTo(4.925f, 12.52f, 4.925f, 12.515f, 4.925f, 12.51f)
                curveTo(4.924f, 12.423f, 4.924f, 12.287f, 5.035f, 12.195f)
                curveTo(5.12f, 12.125f, 5.18f, 12.23f, 5.208f, 12.278f)
                curveTo(5.219f, 12.297f, 5.225f, 12.307f, 5.225f, 12.293f)
                curveTo(5.225f, 12.272f, 5.205f, 12.231f, 5.183f, 12.185f)
                curveTo(5.153f, 12.124f, 5.118f, 12.052f, 5.118f, 12.001f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.107f, 12.001f)
                curveTo(8.107f, 11.913f, 8.332f, 11.71f, 8.332f, 11.71f)
                verticalLineTo(11.727f)
                curveTo(8.363f, 11.752f, 8.564f, 11.918f, 8.564f, 11.999f)
                curveTo(8.564f, 12.049f, 8.538f, 12.122f, 8.516f, 12.184f)
                curveTo(8.499f, 12.231f, 8.485f, 12.272f, 8.485f, 12.293f)
                curveTo(8.485f, 12.307f, 8.491f, 12.297f, 8.502f, 12.278f)
                curveTo(8.529f, 12.23f, 8.59f, 12.125f, 8.674f, 12.195f)
                curveTo(8.786f, 12.287f, 8.785f, 12.423f, 8.785f, 12.51f)
                curveTo(8.785f, 12.515f, 8.785f, 12.52f, 8.785f, 12.524f)
                curveTo(8.785f, 12.551f, 8.785f, 12.551f, 8.781f, 12.538f)
                curveTo(8.773f, 12.511f, 8.749f, 12.425f, 8.674f, 12.425f)
                curveTo(8.564f, 12.425f, 8.485f, 12.524f, 8.485f, 12.524f)
                verticalLineTo(12.694f)
                curveTo(8.485f, 12.694f, 8.499f, 12.835f, 8.564f, 12.765f)
                curveTo(8.63f, 12.694f, 8.644f, 12.851f, 8.564f, 12.851f)
                curveTo(8.524f, 12.851f, 8.482f, 12.894f, 8.441f, 12.936f)
                curveTo(8.402f, 12.977f, 8.363f, 13.017f, 8.328f, 13.017f)
                verticalLineTo(13.002f)
                curveTo(8.294f, 13f, 8.266f, 12.965f, 8.237f, 12.929f)
                curveTo(8.206f, 12.891f, 8.175f, 12.851f, 8.134f, 12.851f)
                curveTo(8.055f, 12.851f, 8.069f, 12.694f, 8.134f, 12.765f)
                curveTo(8.2f, 12.835f, 8.214f, 12.694f, 8.214f, 12.694f)
                verticalLineTo(12.524f)
                curveTo(8.214f, 12.524f, 8.134f, 12.425f, 8.024f, 12.425f)
                curveTo(7.949f, 12.425f, 7.925f, 12.511f, 7.917f, 12.538f)
                curveTo(7.914f, 12.551f, 7.914f, 12.551f, 7.914f, 12.524f)
                curveTo(7.914f, 12.52f, 7.914f, 12.515f, 7.914f, 12.51f)
                curveTo(7.913f, 12.423f, 7.913f, 12.287f, 8.024f, 12.195f)
                curveTo(8.109f, 12.125f, 8.169f, 12.23f, 8.197f, 12.278f)
                curveTo(8.208f, 12.297f, 8.214f, 12.307f, 8.214f, 12.293f)
                curveTo(8.214f, 12.272f, 8.194f, 12.231f, 8.172f, 12.185f)
                curveTo(8.142f, 12.124f, 8.107f, 12.052f, 8.107f, 12.001f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.894f, 11.475f)
                curveTo(5.094f, 11.475f, 5.135f, 11.094f, 5.135f, 11.094f)
                curveTo(5.135f, 11.094f, 5.303f, 10.92f, 5.303f, 11.048f)
                curveTo(5.303f, 11.116f, 5.255f, 11.203f, 5.219f, 11.268f)
                curveTo(5.187f, 11.326f, 5.164f, 11.367f, 5.189f, 11.367f)
                horizontalLineTo(5.467f)
                curveTo(5.696f, 11.367f, 5.427f, 11.475f, 5.303f, 11.522f)
                curveTo(5.247f, 11.544f, 5.207f, 11.555f, 5.169f, 11.566f)
                curveTo(5.123f, 11.579f, 5.079f, 11.592f, 5.012f, 11.621f)
                curveTo(4.89f, 11.674f, 4.837f, 12.023f, 4.894f, 12.136f)
                curveTo(4.951f, 12.248f, 4.837f, 12.2f, 4.79f, 12.136f)
                curveTo(4.764f, 12.1f, 4.745f, 12.149f, 4.719f, 12.218f)
                curveTo(4.697f, 12.274f, 4.671f, 12.342f, 4.633f, 12.388f)
                curveTo(4.559f, 12.478f, 4.56f, 12.399f, 4.561f, 12.227f)
                curveTo(4.562f, 12.199f, 4.562f, 12.168f, 4.562f, 12.136f)
                curveTo(4.562f, 11.984f, 4.592f, 11.983f, 4.637f, 11.981f)
                curveTo(4.661f, 11.979f, 4.689f, 11.978f, 4.719f, 11.954f)
                curveTo(4.784f, 11.902f, 4.792f, 11.876f, 4.811f, 11.809f)
                curveTo(4.818f, 11.786f, 4.826f, 11.759f, 4.837f, 11.725f)
                curveTo(4.884f, 11.589f, 4.633f, 11.804f, 4.562f, 11.905f)
                curveTo(4.519f, 11.967f, 4.489f, 11.974f, 4.444f, 11.984f)
                curveTo(4.415f, 11.991f, 4.38f, 11.999f, 4.331f, 12.023f)
                curveTo(4.252f, 12.064f, 4.274f, 11.984f, 4.3f, 11.888f)
                curveTo(4.315f, 11.833f, 4.331f, 11.772f, 4.331f, 11.725f)
                curveTo(4.331f, 11.643f, 4.38f, 11.664f, 4.443f, 11.691f)
                curveTo(4.48f, 11.707f, 4.522f, 11.725f, 4.562f, 11.725f)
                curveTo(4.663f, 11.725f, 4.716f, 11.682f, 4.78f, 11.629f)
                curveTo(4.783f, 11.626f, 4.787f, 11.624f, 4.79f, 11.621f)
                curveTo(4.842f, 11.579f, 4.729f, 11.591f, 4.595f, 11.606f)
                curveTo(4.549f, 11.612f, 4.501f, 11.617f, 4.456f, 11.621f)
                curveTo(4.352f, 11.629f, 4.345f, 11.623f, 4.32f, 11.6f)
                curveTo(4.301f, 11.583f, 4.273f, 11.557f, 4.192f, 11.522f)
                curveTo(3.998f, 11.438f, 4.316f, 11.475f, 4.456f, 11.522f)
                curveTo(4.533f, 11.549f, 4.598f, 11.531f, 4.675f, 11.51f)
                curveTo(4.736f, 11.493f, 4.805f, 11.475f, 4.894f, 11.475f)
                close()
                moveTo(8.778f, 11.475f)
                curveTo(8.578f, 11.475f, 8.538f, 11.094f, 8.538f, 11.094f)
                curveTo(8.538f, 11.094f, 8.37f, 10.92f, 8.37f, 11.048f)
                curveTo(8.37f, 11.116f, 8.417f, 11.203f, 8.454f, 11.268f)
                curveTo(8.486f, 11.326f, 8.509f, 11.367f, 8.483f, 11.367f)
                horizontalLineTo(8.206f)
                curveTo(7.977f, 11.367f, 8.246f, 11.475f, 8.37f, 11.522f)
                curveTo(8.426f, 11.544f, 8.466f, 11.555f, 8.504f, 11.566f)
                curveTo(8.55f, 11.579f, 8.593f, 11.592f, 8.66f, 11.621f)
                curveTo(8.783f, 11.674f, 8.835f, 12.023f, 8.778f, 12.136f)
                curveTo(8.722f, 12.248f, 8.835f, 12.2f, 8.882f, 12.136f)
                curveTo(8.908f, 12.1f, 8.927f, 12.149f, 8.954f, 12.218f)
                curveTo(8.975f, 12.274f, 9.001f, 12.342f, 9.04f, 12.388f)
                curveTo(9.114f, 12.478f, 9.113f, 12.399f, 9.111f, 12.227f)
                curveTo(9.111f, 12.199f, 9.111f, 12.168f, 9.111f, 12.136f)
                curveTo(9.111f, 11.984f, 9.08f, 11.983f, 9.035f, 11.981f)
                curveTo(9.011f, 11.979f, 8.983f, 11.978f, 8.953f, 11.954f)
                curveTo(8.889f, 11.902f, 8.881f, 11.876f, 8.862f, 11.809f)
                curveTo(8.855f, 11.786f, 8.847f, 11.759f, 8.835f, 11.725f)
                curveTo(8.788f, 11.589f, 9.04f, 11.804f, 9.111f, 11.905f)
                curveTo(9.154f, 11.967f, 9.184f, 11.974f, 9.229f, 11.984f)
                curveTo(9.258f, 11.991f, 9.293f, 11.999f, 9.341f, 12.023f)
                curveTo(9.42f, 12.064f, 9.399f, 11.984f, 9.373f, 11.888f)
                curveTo(9.358f, 11.833f, 9.341f, 11.772f, 9.341f, 11.725f)
                curveTo(9.341f, 11.643f, 9.292f, 11.664f, 9.229f, 11.691f)
                curveTo(9.192f, 11.707f, 9.15f, 11.725f, 9.111f, 11.725f)
                curveTo(9.009f, 11.725f, 8.957f, 11.682f, 8.893f, 11.629f)
                curveTo(8.889f, 11.626f, 8.886f, 11.624f, 8.882f, 11.621f)
                curveTo(8.83f, 11.579f, 8.943f, 11.591f, 9.077f, 11.606f)
                curveTo(9.123f, 11.612f, 9.172f, 11.617f, 9.217f, 11.621f)
                curveTo(9.32f, 11.629f, 9.327f, 11.623f, 9.353f, 11.6f)
                curveTo(9.372f, 11.583f, 9.4f, 11.557f, 9.481f, 11.522f)
                curveTo(9.674f, 11.438f, 9.356f, 11.475f, 9.217f, 11.522f)
                curveTo(9.14f, 11.549f, 9.075f, 11.531f, 8.998f, 11.51f)
                curveTo(8.936f, 11.493f, 8.867f, 11.475f, 8.778f, 11.475f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.654f, 7.713f)
                horizontalLineTo(8.077f)
                verticalLineTo(9.922f)
                curveTo(8.077f, 9.922f, 7.817f, 11.023f, 6.865f, 11.023f)
                curveTo(5.914f, 11.023f, 5.654f, 9.922f, 5.654f, 9.922f)
                verticalLineTo(7.713f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.192f, 7.681f)
                horizontalLineTo(6.558f)
                verticalLineTo(8.949f)
                horizontalLineTo(5.652f)
                verticalLineTo(9.402f)
                horizontalLineTo(6.558f)
                verticalLineTo(11.033f)
                horizontalLineTo(7.192f)
                verticalLineTo(9.402f)
                horizontalLineTo(8.098f)
                verticalLineTo(8.949f)
                horizontalLineTo(7.192f)
                verticalLineTo(7.681f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.063f, 8.318f)
                curveTo(6.124f, 8.318f, 6.153f, 8.267f, 6.121f, 8.222f)
                curveTo(6.104f, 8.198f, 6.069f, 8.191f, 6.042f, 8.206f)
                curveTo(6.04f, 8.208f, 6.038f, 8.209f, 6.036f, 8.211f)
                curveTo(6.026f, 8.208f, 6.014f, 8.205f, 6.001f, 8.201f)
                curveTo(5.988f, 8.197f, 5.975f, 8.197f, 5.963f, 8.201f)
                curveTo(5.948f, 8.206f, 5.94f, 8.191f, 5.947f, 8.097f)
                curveTo(5.954f, 8.071f, 5.99f, 8.055f, 6.073f, 8.055f)
                curveTo(6.226f, 8.055f, 6.288f, 8.071f, 6.288f, 8.086f)
                verticalLineTo(8.31f)
                lineTo(6.214f, 8.377f)
                curveTo(6.179f, 8.409f, 6.204f, 8.464f, 6.254f, 8.464f)
                horizontalLineTo(6.288f)
                verticalLineTo(8.635f)
                curveTo(6.242f, 8.672f, 6.2f, 8.689f, 6.164f, 8.689f)
                curveTo(6.027f, 8.689f, 5.951f, 8.638f, 5.948f, 8.578f)
                curveTo(5.949f, 8.56f, 5.95f, 8.547f, 5.95f, 8.538f)
                lineTo(5.962f, 8.542f)
                curveTo(5.975f, 8.546f, 5.988f, 8.547f, 6.001f, 8.543f)
                lineTo(6.006f, 8.541f)
                curveTo(6.011f, 8.539f, 6.014f, 8.538f, 6.016f, 8.539f)
                curveTo(6.018f, 8.541f, 6.018f, 8.546f, 6.017f, 8.558f)
                lineTo(6.016f, 8.575f)
                curveTo(6.016f, 8.603f, 6.041f, 8.627f, 6.072f, 8.627f)
                curveTo(6.103f, 8.628f, 6.129f, 8.606f, 6.13f, 8.577f)
                curveTo(6.132f, 8.478f, 6.077f, 8.421f, 5.984f, 8.441f)
                curveTo(5.93f, 8.425f, 5.892f, 8.426f, 5.862f, 8.46f)
                curveTo(5.841f, 8.485f, 5.838f, 8.505f, 5.835f, 8.578f)
                curveTo(5.839f, 8.703f, 5.972f, 8.791f, 6.164f, 8.791f)
                curveTo(6.238f, 8.791f, 6.311f, 8.758f, 6.384f, 8.695f)
                curveTo(6.395f, 8.685f, 6.401f, 8.672f, 6.401f, 8.658f)
                verticalLineTo(8.413f)
                curveTo(6.401f, 8.396f, 6.393f, 8.381f, 6.379f, 8.372f)
                lineTo(6.385f, 8.367f)
                curveTo(6.395f, 8.358f, 6.401f, 8.345f, 6.401f, 8.331f)
                verticalLineTo(8.086f)
                curveTo(6.401f, 7.981f, 6.293f, 7.953f, 6.073f, 7.953f)
                curveTo(5.943f, 7.953f, 5.858f, 7.991f, 5.835f, 8.082f)
                curveTo(5.823f, 8.237f, 5.869f, 8.329f, 5.982f, 8.303f)
                curveTo(6.017f, 8.313f, 6.043f, 8.318f, 6.063f, 8.318f)
                close()
                moveTo(7.654f, 8.222f)
                curveTo(7.622f, 8.267f, 7.651f, 8.318f, 7.712f, 8.318f)
                curveTo(7.732f, 8.318f, 7.758f, 8.313f, 7.793f, 8.303f)
                curveTo(7.906f, 8.329f, 7.952f, 8.237f, 7.939f, 8.082f)
                curveTo(7.916f, 7.991f, 7.831f, 7.953f, 7.702f, 7.953f)
                curveTo(7.481f, 7.953f, 7.373f, 7.981f, 7.373f, 8.086f)
                verticalLineTo(8.331f)
                curveTo(7.373f, 8.345f, 7.379f, 8.358f, 7.39f, 8.367f)
                lineTo(7.395f, 8.372f)
                curveTo(7.382f, 8.381f, 7.373f, 8.396f, 7.373f, 8.413f)
                verticalLineTo(8.658f)
                curveTo(7.373f, 8.672f, 7.38f, 8.685f, 7.391f, 8.695f)
                curveTo(7.464f, 8.758f, 7.537f, 8.791f, 7.611f, 8.791f)
                curveTo(7.803f, 8.791f, 7.935f, 8.703f, 7.939f, 8.578f)
                curveTo(7.937f, 8.505f, 7.934f, 8.485f, 7.912f, 8.46f)
                curveTo(7.883f, 8.426f, 7.845f, 8.425f, 7.79f, 8.441f)
                curveTo(7.698f, 8.421f, 7.643f, 8.478f, 7.645f, 8.577f)
                curveTo(7.646f, 8.606f, 7.672f, 8.628f, 7.703f, 8.627f)
                curveTo(7.734f, 8.627f, 7.759f, 8.603f, 7.758f, 8.575f)
                lineTo(7.758f, 8.558f)
                verticalLineTo(8.558f)
                curveTo(7.757f, 8.546f, 7.757f, 8.541f, 7.759f, 8.539f)
                curveTo(7.761f, 8.538f, 7.763f, 8.539f, 7.768f, 8.541f)
                lineTo(7.774f, 8.543f)
                curveTo(7.786f, 8.547f, 7.8f, 8.546f, 7.812f, 8.542f)
                lineTo(7.824f, 8.538f)
                curveTo(7.825f, 8.547f, 7.826f, 8.56f, 7.826f, 8.578f)
                curveTo(7.824f, 8.638f, 7.747f, 8.689f, 7.611f, 8.689f)
                curveTo(7.575f, 8.689f, 7.533f, 8.672f, 7.486f, 8.635f)
                verticalLineTo(8.464f)
                horizontalLineTo(7.52f)
                curveTo(7.571f, 8.464f, 7.596f, 8.409f, 7.56f, 8.377f)
                lineTo(7.486f, 8.31f)
                verticalLineTo(8.086f)
                curveTo(7.486f, 8.071f, 7.549f, 8.055f, 7.702f, 8.055f)
                curveTo(7.785f, 8.055f, 7.821f, 8.071f, 7.828f, 8.097f)
                curveTo(7.835f, 8.191f, 7.826f, 8.206f, 7.812f, 8.201f)
                curveTo(7.799f, 8.197f, 7.786f, 8.197f, 7.774f, 8.201f)
                curveTo(7.76f, 8.205f, 7.748f, 8.208f, 7.739f, 8.211f)
                curveTo(7.737f, 8.209f, 7.735f, 8.208f, 7.732f, 8.206f)
                curveTo(7.706f, 8.191f, 7.671f, 8.198f, 7.654f, 8.222f)
                close()
                moveTo(7.845f, 8.534f)
                lineTo(7.842f, 8.534f)
                lineTo(7.844f, 8.534f)
                lineTo(7.845f, 8.534f)
                close()
                moveTo(7.712f, 9.948f)
                curveTo(7.651f, 9.948f, 7.622f, 9.897f, 7.654f, 9.852f)
                curveTo(7.671f, 9.828f, 7.706f, 9.821f, 7.732f, 9.837f)
                curveTo(7.735f, 9.838f, 7.737f, 9.84f, 7.739f, 9.841f)
                curveTo(7.748f, 9.839f, 7.76f, 9.835f, 7.774f, 9.831f)
                curveTo(7.786f, 9.828f, 7.799f, 9.828f, 7.812f, 9.832f)
                curveTo(7.826f, 9.837f, 7.835f, 9.821f, 7.828f, 9.728f)
                curveTo(7.821f, 9.702f, 7.785f, 9.686f, 7.702f, 9.686f)
                curveTo(7.549f, 9.686f, 7.486f, 9.702f, 7.486f, 9.716f)
                verticalLineTo(9.94f)
                lineTo(7.56f, 10.007f)
                curveTo(7.596f, 10.039f, 7.571f, 10.094f, 7.52f, 10.094f)
                horizontalLineTo(7.486f)
                verticalLineTo(10.266f)
                curveTo(7.533f, 10.302f, 7.575f, 10.319f, 7.611f, 10.319f)
                curveTo(7.747f, 10.319f, 7.824f, 10.268f, 7.826f, 10.208f)
                curveTo(7.826f, 10.191f, 7.825f, 10.178f, 7.824f, 10.169f)
                lineTo(7.812f, 10.173f)
                curveTo(7.8f, 10.177f, 7.786f, 10.177f, 7.774f, 10.173f)
                lineTo(7.768f, 10.171f)
                lineTo(7.768f, 10.171f)
                curveTo(7.763f, 10.17f, 7.761f, 10.169f, 7.759f, 10.17f)
                curveTo(7.757f, 10.171f, 7.757f, 10.176f, 7.758f, 10.189f)
                lineTo(7.758f, 10.205f)
                curveTo(7.759f, 10.234f, 7.734f, 10.257f, 7.703f, 10.258f)
                curveTo(7.672f, 10.258f, 7.646f, 10.236f, 7.645f, 10.208f)
                curveTo(7.643f, 10.109f, 7.698f, 10.052f, 7.79f, 10.071f)
                curveTo(7.845f, 10.055f, 7.883f, 10.057f, 7.912f, 10.09f)
                curveTo(7.934f, 10.115f, 7.937f, 10.135f, 7.939f, 10.208f)
                curveTo(7.935f, 10.333f, 7.803f, 10.421f, 7.611f, 10.421f)
                curveTo(7.537f, 10.421f, 7.464f, 10.388f, 7.391f, 10.325f)
                curveTo(7.38f, 10.316f, 7.373f, 10.302f, 7.373f, 10.288f)
                verticalLineTo(10.043f)
                curveTo(7.373f, 10.027f, 7.382f, 10.012f, 7.395f, 10.003f)
                lineTo(7.39f, 9.998f)
                curveTo(7.379f, 9.988f, 7.373f, 9.975f, 7.373f, 9.961f)
                verticalLineTo(9.716f)
                curveTo(7.373f, 9.611f, 7.481f, 9.583f, 7.702f, 9.583f)
                curveTo(7.831f, 9.583f, 7.916f, 9.622f, 7.939f, 9.712f)
                curveTo(7.952f, 9.867f, 7.906f, 9.96f, 7.793f, 9.933f)
                curveTo(7.758f, 9.943f, 7.732f, 9.948f, 7.712f, 9.948f)
                close()
                moveTo(6.063f, 9.948f)
                curveTo(6.124f, 9.948f, 6.153f, 9.897f, 6.121f, 9.852f)
                curveTo(6.104f, 9.828f, 6.069f, 9.821f, 6.042f, 9.837f)
                curveTo(6.04f, 9.838f, 6.038f, 9.84f, 6.036f, 9.841f)
                curveTo(6.026f, 9.839f, 6.014f, 9.835f, 6.001f, 9.831f)
                curveTo(5.988f, 9.828f, 5.975f, 9.828f, 5.963f, 9.832f)
                curveTo(5.948f, 9.837f, 5.94f, 9.821f, 5.947f, 9.728f)
                curveTo(5.954f, 9.702f, 5.99f, 9.686f, 6.073f, 9.686f)
                curveTo(6.226f, 9.686f, 6.288f, 9.702f, 6.288f, 9.716f)
                verticalLineTo(9.94f)
                lineTo(6.214f, 10.007f)
                curveTo(6.179f, 10.039f, 6.204f, 10.094f, 6.254f, 10.094f)
                horizontalLineTo(6.288f)
                verticalLineTo(10.266f)
                curveTo(6.242f, 10.302f, 6.2f, 10.319f, 6.164f, 10.319f)
                curveTo(6.027f, 10.319f, 5.951f, 10.268f, 5.948f, 10.208f)
                curveTo(5.949f, 10.191f, 5.95f, 10.178f, 5.95f, 10.169f)
                lineTo(5.962f, 10.173f)
                curveTo(5.975f, 10.177f, 5.988f, 10.177f, 6.001f, 10.173f)
                curveTo(6.003f, 10.172f, 6.005f, 10.172f, 6.006f, 10.171f)
                curveTo(6.011f, 10.17f, 6.014f, 10.169f, 6.016f, 10.17f)
                curveTo(6.018f, 10.171f, 6.018f, 10.176f, 6.017f, 10.189f)
                curveTo(6.017f, 10.193f, 6.017f, 10.199f, 6.016f, 10.205f)
                curveTo(6.016f, 10.234f, 6.041f, 10.257f, 6.072f, 10.258f)
                curveTo(6.103f, 10.258f, 6.129f, 10.236f, 6.13f, 10.208f)
                curveTo(6.132f, 10.109f, 6.077f, 10.052f, 5.984f, 10.071f)
                curveTo(5.93f, 10.055f, 5.892f, 10.057f, 5.862f, 10.09f)
                curveTo(5.841f, 10.115f, 5.838f, 10.135f, 5.835f, 10.208f)
                curveTo(5.839f, 10.333f, 5.972f, 10.421f, 6.164f, 10.421f)
                curveTo(6.238f, 10.421f, 6.311f, 10.388f, 6.384f, 10.325f)
                curveTo(6.395f, 10.316f, 6.401f, 10.302f, 6.401f, 10.288f)
                verticalLineTo(10.043f)
                curveTo(6.401f, 10.027f, 6.393f, 10.012f, 6.379f, 10.003f)
                lineTo(6.385f, 9.998f)
                curveTo(6.395f, 9.988f, 6.401f, 9.975f, 6.401f, 9.961f)
                verticalLineTo(9.716f)
                curveTo(6.401f, 9.611f, 6.293f, 9.583f, 6.073f, 9.583f)
                curveTo(5.943f, 9.583f, 5.858f, 9.622f, 5.835f, 9.712f)
                curveTo(5.823f, 9.867f, 5.869f, 9.96f, 5.982f, 9.933f)
                curveTo(6.017f, 9.943f, 6.043f, 9.948f, 6.063f, 9.948f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun SerbiaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.Serbia,
            contentDescription = "Serbia Flag"
        )
    }
}
